<template>
  <div>
    <b-spinner
      v-if="modalLoading"
      variant="secondary"
      role="status"
      size="sm"
      class="wizard-spinner"
      style="top: 36%"
    />
    <Form-wizard
      ref="comp_form"
      class="pre-register-form"
      v-show="(!onlineCompliance || siteName) && showScreen && !modalLoading"
    >
      <tab-content>
        <div
          class="compliance-firstscreen"
          :class="{ 'online-comp-width': onlineCompliance }"
        >
          <section
            v-if="onlineCompliance"
            :class="
              onlineCompliance
                ? 'no-usr-pre-reg-head-tab1'
                : 'pre-reg-head-tab1'
            "
          >
            <div class="visit-register-header-comp">
              <div class="logo">
                <img
                  v-if="journeyLogo"
                  ref="logo"
                  class="img-logo"
                  :src="journeyLogo"
                  alt=""
                  :style="logoStyle"
                />
                <img
                  v-else-if="currentEntity.logo"
                  ref="logo"
                  class="img-logo"
                  :src="currentEntity.logo"
                  alt=""
                  :style="logoStyle"
                />
                <img v-else class="logo-img" src="@/assets/images/logo-lg.svg" alt="-visipoint-logo" />
              </div>
            </div>
            <h3 class="welcome-msg">{{ $t("common.compliance") }}</h3>
            <div class="online-compliance-user-details">
              {{
                (registrationMethod ==
                  "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED" &&
                  allCompleted() &&
                  this.journeyStage != "ready_to_sign_in") ||
                (registrationMethod !=
                  "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED" &&
                  allPassed())
                  ? this.$t("complianceList.ThanksForCompliance") + " "
                  : ""
              }}
              {{ mainMsg }}
            </div>
          </section>

          <template @click="nextTab" v-if="compExists">
            <p v-if="visitRejected || visitApproved" class="firsttxt-card">
              {{ visitRejected ? $t("dashboard.grid.journeStages.rejectedByAdmin") : $t("dashboard.grid.journeStages.approvedByAdmin") + " " }} <b>{{
                action_by
              }}</b> {{ $t("common.at").toLowerCase() }}
              {{ getDate(scan_time) }}.
              <br>
              <span
                  v-if="visitRejected"
                  :class="{ 'break-word': rejectionReason.length > 37 }"
                  ><b>{{ $t("common.reason") }}:</b> {{ rejectionReason }}</span
                >
            </p>
            <!-- @click="!data.isDue ? nextTab(data) : null" -->
            <!-- :style="!data.isDue ? 'cursor:pointer' : 'cursor:not-allowed'" -->
            <div
              v-for="(data, index) of allUserCompliance"
              :key="'all' + index"
            >
              <div class="compliance-allCardCon" :style="data.isDue && onlineCompliance ? 'cursor: not-allowed' : 'cursor: pointer'">
                <div
                  class="allcard-container d-flex"
                  :style="index == allUserCompliance.length - 1 ? (onlineCompliance ? 'margin-bottom: 0 !important' : 'margin-bottom: 40px !important') : ''"
                  @click="data.isDue && onlineCompliance ? null : nextTab(data)"
                >
                  <div class="card-left">
                    <svg v-if="getUserStatus(data).id == 0"
                    width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle opacity="0.94" cx="8" cy="8" r="8" fill="#AFAFAF"/>
                    <path d="M12.2148 5.31197C12.1211 5.23984 12.0138 5.18637 11.8991 5.1546C11.7844 5.12284 11.6644 5.11341 11.5461 5.12685C11.4278 5.14029 11.3134 5.17634 11.2095 5.23294C11.1056 5.28954 11.0143 5.36559 10.9407 5.45672L7.22228 10.0538L5.04983 8.4194C4.8756 8.28815 4.65528 8.22958 4.43733 8.25659C4.21939 8.2836 4.02167 8.39396 3.88768 8.56341C3.75369 8.73285 3.6944 8.94749 3.72285 9.16011C3.75131 9.37274 3.86517 9.56592 4.0394 9.69717L6.95147 11.8878C7.04116 11.9552 7.14409 12.0039 7.25382 12.0309C7.36355 12.0578 7.47772 12.0624 7.58919 12.0443C7.70775 12.0311 7.82237 11.9952 7.9265 11.9386C8.03063 11.882 8.12221 11.8059 8.196 11.7147L12.3678 6.55562C12.5165 6.37139 12.5839 6.13687 12.5552 5.90359C12.5265 5.67032 12.404 5.45738 12.2147 5.31156" fill="white"/>
                    </svg>
                    
                    <svg v-else-if="getUserStatus(data).id == 1"
                    width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle opacity="0.94" cx="8" cy="8" r="8" fill="#34C38F"/>
                    <path d="M12.2148 5.31197C12.1211 5.23984 12.0138 5.18637 11.8991 5.1546C11.7844 5.12284 11.6644 5.11341 11.5461 5.12685C11.4278 5.14029 11.3134 5.17634 11.2095 5.23294C11.1056 5.28954 11.0143 5.36559 10.9407 5.45672L7.22228 10.0538L5.04983 8.4194C4.8756 8.28815 4.65528 8.22958 4.43733 8.25659C4.21939 8.2836 4.02167 8.39396 3.88768 8.56341C3.75369 8.73285 3.6944 8.94749 3.72285 9.16011C3.75131 9.37274 3.86517 9.56592 4.0394 9.69717L6.95147 11.8878C7.04116 11.9552 7.14409 12.0039 7.25382 12.0309C7.36355 12.0578 7.47772 12.0624 7.58919 12.0443C7.70775 12.0311 7.82237 11.9952 7.9265 11.9386C8.03063 11.882 8.12221 11.8059 8.196 11.7147L12.3678 6.55562C12.5165 6.37139 12.5839 6.13687 12.5552 5.90359C12.5265 5.67032 12.404 5.45738 12.2147 5.31156" fill="white"/>
                    </svg>

                    <svg v-else-if="getUserStatus(data).id == 2"
                    width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 0C3.57333 0 0 3.57333 0 8C0 12.4267 3.57333 16 8 16C12.4267 16 16 12.4267 16 8C16 3.57333 12.4267 0 8 0ZM12.0711 10.7022C12.4444 11.0756 12.4444 11.68 12.0711 12.0533C11.8756 12.2489 11.6444 12.3378 11.3956 12.3378C11.1467 12.3378 10.8978 12.2489 10.72 12.0533L8.05333 9.38667L5.36889 12.0533C5.17333 12.2489 4.94222 12.3378 4.69333 12.3378C4.44444 12.3378 4.19556 12.2489 4.01778 12.0533C3.64444 11.68 3.64444 11.0756 4.01778 10.7022L6.70222 8.01778L4.01778 5.35111C3.64444 4.97778 3.64444 4.37333 4.01778 4C4.39111 3.62667 4.99556 3.62667 5.36889 4L8.05333 6.68444L10.7378 4C11.1111 3.62667 11.7156 3.62667 12.0889 4C12.4622 4.37333 12.4622 4.97778 12.0889 5.35111L9.40444 8.03556L12.0711 10.7022Z" fill="#F46A6A"/>
                    </svg>

                    <svg v-else-if="getUserStatus(data).id == 3"
                    width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle opacity="0.94" cx="8" cy="8" r="8" fill="#103F5E"/>
                    <path d="M12.2148 5.31197C12.1211 5.23984 12.0138 5.18637 11.8991 5.1546C11.7844 5.12284 11.6644 5.11341 11.5461 5.12685C11.4278 5.14029 11.3134 5.17634 11.2095 5.23294C11.1056 5.28954 11.0143 5.36559 10.9407 5.45672L7.22228 10.0538L5.04983 8.4194C4.8756 8.28815 4.65528 8.22958 4.43733 8.25659C4.21939 8.2836 4.02167 8.39396 3.88768 8.56341C3.75369 8.73285 3.6944 8.94749 3.72285 9.16011C3.75131 9.37274 3.86517 9.56592 4.0394 9.69717L6.95147 11.8878C7.04116 11.9552 7.14409 12.0039 7.25382 12.0309C7.36355 12.0578 7.47772 12.0624 7.58919 12.0443C7.70775 12.0311 7.82237 11.9952 7.9265 11.9386C8.03063 11.882 8.12221 11.8059 8.196 11.7147L12.3678 6.55562C12.5165 6.37139 12.5839 6.13687 12.5552 5.90359C12.5265 5.67032 12.404 5.45738 12.2147 5.31156" fill="white"/>
                    </svg>

                  </div>
                  <div class="card-centercontent">
                    <div class="card-data">
                      <span class="name"
                        >{{ data.name }}
                        {{
                          getIsOptional(data)
                            ? $t("common.optionalWithBrackets")
                            : ""
                        }}</span
                      >
                    </div>
                    <div class="card-status">
                      <span
                        :class="{
                          status: getStatus(data).id == 0,
                          'second-status':
                            getStatus(data).id !== 0 || data.isDue,
                        }"
                        >{{ getUserStatus(data).text }}</span
                      >
                    </div>
                  </div>
                  <div class="card-right">
                    <svg
                    :style="data.isDue && onlineCompliance ? 'opacity: 0.4' : ''"
                      width="8"
                      height="13"
                      viewBox="0 0 8 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.05746 0.393285L6.87122 5.58648C7.1094 5.84411 7.22222 6.16953 7.22222 6.50851C7.22222 6.84749 7.1094 7.17291 6.87122 7.43054L2.05746 12.6237C1.59363 13.1254 0.828947 13.1254 0.352586 12.6237C-0.123776 12.122 -0.11124 11.2949 0.352586 10.7797L4.31391 6.50851L0.352586 2.22378C-0.11124 1.72209 -0.11124 0.894978 0.352586 0.379726C0.816412 -0.135526 1.5811 -0.121966 2.05746 0.393285Z"
                        fill="#495057"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="aprove-reject">
              <div v-if="visitRejected || visitApproved">
                {{ visitRejected ? $t("dashboard.grid.journeStages.rejectedByAdmin") : $t("dashboard.grid.journeStages.approvedByAdmin") + " " }} <b>{{
                  action_by
                }}</b> {{ $t("common.at").toLowerCase() }}
                {{ getDate(scan_time) }}.
                <span
                  v-if="visitRejected"
                  :class="{ 'break-word': rejectionReason.length > 37 }"
                  ><b>{{ $t("common.reason") }}:</b> {{ rejectionReason }}</span
                >
              </div>

              <div v-else style="font-size: 15px">
                {{ $t("common.notes.areYouSureYouWant") }} <strong class="strong-txt">“{{$t("common.approve")}}”</strong> {{ $t("common.or") }}
                <strong class="strong-txt">“{{$t("common.reject")}}”</strong> {{ $t("complianceList.thisVisitRequestOf") }} {{ firstName + " " + lastName }}?
                <!-- <hr class="vertical-line" /> -->
              </div>
            </div>
          </template>

          <hr class="vertical-line" v-if="manageVisit" style="margin: 40px 0 24px 0;" />

          <div class="modal-actions-btns" v-if="manageVisit" style="width: 416px">
            <VpButton
              v-if="!visitApproved"
              :text="$t('common.approve')"
              :disabled="!checkPassed"
              @click="selectAction('approve')"
            />
            <VpButton
              v-if="!visitRejected"
              :text="$t('common.reject')"
              :disabled="isLoading"
              :isLoading="isLoading"
              :isDanger="true"
              @click="selectAction('reject')"
            />
          </div>
        </div>
      </tab-content>

      <tab-content
        v-if="data && compExists && !approveClicked && !rejectClicked"
      >
        <div
          class="compliance-secondScreen"
          :class="{ 'online-comp-width': onlineCompliance }"
        >
        <div v-if="onlineCompliance" class="text-center">
          <div class="visit-register-header-comp">
              <div class="logo">
                <img
                  v-if="journeyLogo"
                  class="img-logo"
                  :src="journeyLogo"
                  alt=""
                  :style="logoStyle"
                />
                <img
                  v-else-if="currentEntity.logo"
                  class="img-logo"
                  :src="currentEntity.logo"
                  alt=""
                  :style="logoStyle"
                />
                <img v-else class="logo-img" src="@/assets/images/logo-lg.svg" alt="-visipoint-logo" />
              </div>
            </div>
          <p class="modal-header-title">{{ $t("common.hello") }} {{ firstName }},</p>
        </div>

        <div class="agreement-quest-template">
          <div class="agreement-container">
            <p class="static-agreement">
              {{ data.name }}
              {{
                getIsOptional(data)
                  ? $t("common.optionalWithBrackets")
                  : ""
              }}
            </p>
          </div>
        </div>
          
          <template>
            <p class="visitcard-status">
              {{
                getUserStatus(data).id == 0
                  ? data.type == "questionnaire" ? (onlineCompliance ? $t("signInOut.questionnaireHeaderUser") : $tc("signInOut.questionnaireHeader", 1)) : (onlineCompliance ? $t("signInOut.complianceHeaderUser") : $tc("signInOut.complianceHeader", 1))
                : getUserStatus(data).id == 1
                  ? $tc("signInOut.complianceCompleted", 1)
                  : `${this.$t("complianceList.complianceResponse")} `
              }}
            </p>

            <div class="user-infocontainer">
              <p class="user-info" v-if="data.pivot && data.pivot.updated_at">
                {{ getDate(data.pivot.updated_at) }}<b> &ensp;<b>•</b>&ensp; </b> {{$t("common.by")}} 
                <template
                  v-if="
                    !onlineCompliance ||
                    (data.pivot.metadata[0] &&
                      data.pivot.metadata[0].actionBy == 'Admin') ||
                    data.pivot.metadata.actionBy == 'Admin'
                  "
                >
                  {{
                    data.pivot.metadata || data.pivot.metadata[0]
                      ? data.pivot.metadata[0]
                        ? (data.pivot.metadata[0].actionBy.toLowerCase() == "admin" ? $t("common.admin").toLowerCase() : $t("common.user").toLowerCase())
                        : (data.pivot.metadata.actionBy.toLowerCase() == "admin" ? $t("common.admin").toLowerCase() : $t("common.user").toLowerCase())
                      : data.pivot.notes
                      ? JSON.parse(data.pivot.notes).actionBy
                      : !onlineCompliance
                      ? $t("common.user").toLowerCase()
                      : null
                  }}
                </template>
                <span v-else>&nbsp;{{ $t("common.you") }}</span>
                <span
                  v-if="
                    !onlineCompliance ||
                    (data.pivot.metadata[0] &&
                      data.pivot.metadata[0].actionBy == 'Admin') ||
                    data.pivot.metadata.actionBy == 'Admin'
                  "
                >
                  <span style="font-weight: 700"
                    >&nbsp;({{
                      data.pivot.full_name_action_by
                        ? data.pivot.full_name_action_by.toLowerCase()
                        : data.pivot.notes
                        ? JSON.parse(data.pivot.notes).fullName
                        : "-"
                    }})</span
                  ></span
                >
              </p>
              <p class="user-info" v-else-if="data.isDue">
                <b>{{ $t("common.notes.note") }}</b>: {{ $t("complianceList.thisComplianceIsDueAt") }} {{ data.due }}
              </p>
            </div>
            <!-- Vaccine Document -->
            <div
              v-if="data.type == 'vaccine_document'"
              class="vaccine-template"
            >
              <div
                class="documents"
                v-if="
                  !onlineCompliance &&
                  vaccine.documentOptions &&
                  vaccine.documentOptions.length > 0
                "
              >
                <b-form-group class="text-muted" label-for="type">
                  <multiselect
                    v-if="!form.document"
                    id="vacc-pcr-doc"
                    v-model="form.document"
                    :options="vaccine.documentOptions"
                    :placeholder="$t('signInOut.selectDocument')"
                    :show-labels="false"
                    label="value"
                    :allowEmpty="true"
                    :taggable="true"
                    deselectLabel
                    @select="updateDocumentDetails"
                  />
                  <div class="alloverlay-layers" v-if="form.document">
                    <div class="closing-overlay" v-if="form.document">
                      <h4 class="overlay-con">{{ form.document.value }}</h4>
                      <span class="overlay-closing" @click="clearDocument">
                        {{ $t("common.remove") }}
                      </span>
                    </div>
                    <ShowDocumentDetails
                      :document_file_src="documentFile.img"
                      :documentDetails="documentDetails"
                    />
                    <div class="note-sep-line"></div>
                  </div>
                </b-form-group>
              </div>

              <template v-if="!form.document">
                <p
                  class="document-details"
                  v-if="
                    !onlineCompliance &&
                    vaccine.documentOptions &&
                    vaccine.documentOptions.length > 0
                  "
                >
                  {{ upperFirst($t("signInOut.addDocManually")) }}
                </p>

                <template
                  v-if="
                    !onlineCompliance ||
                    (data.originalPivot && data.originalPivot.length == 0)
                  "
                >
                  <div>
                    <!-- vaccine-pcr toggle -->
                    <b-form-group v-if="isPcrEnabled" class="checkbox-wrapper">
                      <div
                        class="d-flex align-items-center align-content-center vaccine-pcrradio"
                      >
                        <b-form-radio
                          v-model="form.vaccine_pcr"
                          value="vaccine"
                          >{{ $t("common.doc.vaccine") }}</b-form-radio
                        >
                        <b-form-radio
                          class="pcr-radio"
                          v-model="form.vaccine_pcr"
                          value="pcr"
                          >{{ $t("common.doc.PCR") }}</b-form-radio
                        >
                      </div>
                    </b-form-group>
                    <!-- vaccine data  -->
                    <div
                      v-if="form.vaccine_pcr == 'vaccine'"
                      class="vaccine-inputs-wrapper"
                    >
                      <!-- <div v-if="!vaccineQrScan" > 
                  #Vaccine QR SCAN INPUT 
                    <div style="position:relative" class='text-center'>
                    <div> <i class="mdi mdi-qrcode-scan mdi-24px scan-icon"></i></div>
                    <button class="scan-btn" @click="$bvModal.show('scanQrModal')">Scan Vaccine QR Code</button>
                    <p class="modal-optional-text">Or add vaccine details manually</p>
                  </div> -->
                      <div v-if="!vaccineQrScan">
                        <!-- Protocol -->
                        <!-- v-model="vaccine.protocols" -->
                        <multiselect
                          id="protocols"
                          class="protocols-multiselect"
                          v-model="vaccine.vaccine_protocol"
                          :options="protocolsOptions"
                          :placeholder="$t('common.doc.vaccineProtocol')"
                          :show-labels="false"
                          @input="updateVaccineProtocol"
                        />
                        <!-- name   -->
                        <b-form-group>
                          <div class="form-group m-d-gruop vaccine-name">
                            <b-form-input
                              id="name"
                              v-model="vaccine.vaccine_name"
                              type="text"
                              required
                              :class="{
                                'cursor-stop':
                                  vaccine.vaccine_name &&
                                  vaccine.vaccine_name.length >= 30,
                                'is-invalid':
                                  submitted &&
                                  $v.vaccine.vaccine_name.$error &&
                                  form.vaccine_pcr == 'vaccine',
                              }"
                              maxlength="30"
                            ></b-form-input>
                            <label for="name">{{ $t("common.doc.vaccineName") }}</label>
                          </div>
                          <div
                            v-if="
                              submitted &&
                              !$v.vaccine.vaccine_name.required &&
                              form.vaccine_pcr == 'vaccine'
                            "
                            class="invalid-feedback"
                          >
                          {{ $t("common.doc.vaccineName") }} {{ $t("common.required") }}
                          </div>
                        </b-form-group>
                        <!-- number   -->
                        <b-form-group>
                          <div class="form-group m-d-gruop batch-num">
                            <b-form-input
                              id="numberr"
                              v-model="vaccine.vaccine_number"
                              type="text"
                              required
                            ></b-form-input>
                            <label for="number"
                              >{{ $t("common.doc.batchNumber") }}
                              {{ $t("common.optionalWithBrackets") }}</label
                            >
                          </div>
                        </b-form-group>
                        <div class="dates-con d-flex">
                          <!-- given date  -->
                          <b-form-group>
                            <date-picker
                              id="date-vaccine"
                              :class="{
                                'is-invalid invalid-date-input':
                                  submitted &&
                                  $v.vaccine.vaccine_expire_date.$error &&
                                  form.vaccine_pcr == 'vaccine',
                              }"
                              v-model="vaccine.vaccine_given_date"
                              :first-day-of-week="1"
                              :placeholder="$t('common.doc.dateTaken')"
                              value-type="format"
                              format="DD/MM/YYYY"
                              :disabledDate="disableDateAfterCurrent"
                            >
                              <i
                                slot="icon-calendar"
                                v-if="!vaccine.vaccine_given_date"
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                                    fill="#787878"
                                  />
                                </svg>
                              </i>
                              <i
                                slot="icon-calendar"
                                v-if="vaccine.vaccine_given_date"
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                                    fill="#103F5E"
                                  />
                                </svg>
                              </i>
                            </date-picker>
                            <div
                              v-if="
                                submitted &&
                                !$v.vaccine.vaccine_given_date.required &&
                                form.vaccine_pcr == 'vaccine'
                              "
                              class="invalid-feedback"
                            >
                            {{ $t("common.doc.vaccineGivenDate") }} {{ $t("common.required") }}
                            </div>
                          </b-form-group>
                          <!-- expire date  -->
                          <!--  type="datetime" -->
                          <b-form-group>
                            <date-picker
                              id="expire_date"
                              :class="{
                                'is-invalid invalid-date-input':
                                  submitted &&
                                  $v.vaccine.vaccine_expire_date.$error &&
                                  form.vaccine_pcr == 'vaccine',
                              }"
                              v-model="vaccine.vaccine_expire_date"
                              :first-day-of-week="1"
                              :placeholder="$t('common.doc.expiryDate')"
                              value-type="format"
                              format="DD/MM/YYYY"
                              :disabled="!vaccine.vaccine_given_date"
                              :disabledDate="disabledExpiredDate"
                              @change="checkExpired()"
                            >
                              <i
                                slot="icon-calendar"
                                v-if="!vaccine.vaccine_expire_date"
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                                    fill="#787878"
                                  />
                                </svg>
                              </i>
                              <i
                                slot="icon-calendar"
                                v-if="vaccine.vaccine_expire_date"
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                                    fill="#103F5E"
                                  />
                                </svg>
                              </i>
                            </date-picker>
                            <div
                              v-if="
                                submitted &&
                                !$v.vaccine.vaccine_expire_date.required &&
                                form.vaccine_pcr == 'vaccine'
                              "
                              class="invalid-feedback"
                            >
                            {{ $t("common.doc.expiryDate") }} {{ $t("common.required") }}
                            </div>
                          </b-form-group>
                        </div>
                        <!-- Vaccine File (upload) -->
                        <div class="mb-3">
                          <div>
                            <button
                              type="button"
                              @click="pickImage"
                              class="upload-btn"
                              :class="{
                                'file-validation':
                                  documentFileErr && !documentFile.img,
                              }"
                            >
                              <b-form-file
                                accept="image/*"
                                id="imagePicker"
                                @change="onFileChange"
                                class="d-none upload-btn"
                                v-model="vaccine.vaccine_document"
                              ></b-form-file>
                              <div class="d-flex justify-content-between w-25">
                                <p
                                  class="mt-3 file-label"
                                  :class="{
                                    'file-label-img-selected': documentFile.img,
                                  }"
                                >
                                {{ $t("common.doc.vaccineFile") }}
                                </p>
                                <span
                                  class="mt-2 paperclip-icon"
                                  v-if="!documentFile.img"
                                  ><i class="mdi mdi-paperclip mdi-24px"></i
                                ></span>
                              </div>
                            </button>
                            <div
                              v-if="documentFile.img"
                              style="position: relative"
                            >
                              <img
                                :class="{
                                  'img-bg':
                                    onlineCompliance &&
                                    data.originalPivot.length != 0,
                                  'img-file':
                                    !onlineCompliance ||
                                    data.originalPivot.length == 0,
                                }"
                                :src="documentFile.img"
                              />
                              <i
                                @click="removeImage()"
                                class="mdi-24px remove-file-icon"
                                style="
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                "
                              >
                                <svg
                                  width="14"
                                  height="19"
                                  viewBox="0 0 14 19"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.3636 2.34047C13.715 2.34047 14 2.64876 14 3.02888C14 3.40919 13.715 3.71728 13.3636 3.71728H13.3548C13.2844 3.71728 13.2253 3.7776 13.2227 3.85558L12.7646 17.2377C12.731 18.2146 11.9762 19 11.0728 19H2.92723C2.02345 19 1.26904 18.2133 1.23544 17.2377L0.777349 3.85558C0.774686 3.77932 0.717158 3.71728 0.645248 3.71728H0.63637C0.28498 3.71728 0 3.40919 0 3.02888C0 2.64876 0.28498 2.34047 0.63637 2.34047H3.73886C3.80881 2.34047 3.88143 2.28035 3.90026 2.20909L4.10764 1.42347C4.32054 0.617499 5.07747 0 5.85253 0H8.14764C8.92269 0 9.67943 0.617352 9.89252 1.42347L10.0999 2.20909C10.1191 2.2817 10.1906 2.34047 10.2613 2.34047H13.3636ZM6.49084 6.19564V15.558C6.49084 15.8622 6.71864 16.1086 6.99989 16.1086C7.28113 16.1086 7.50894 15.8622 7.50894 15.558V6.19564C7.50894 5.89139 7.28113 5.64497 6.99989 5.64497C6.71864 5.64497 6.49084 5.8914 6.49084 6.19564ZM3.6909 6.21178L3.94552 15.5741C3.95387 15.8781 4.18824 16.1175 4.4693 16.1084C4.75037 16.0996 4.97162 15.8459 4.96326 15.5418L4.70864 6.17952C4.70047 5.87546 4.46592 5.63612 4.18486 5.64517C3.90378 5.654 3.68272 5.90774 3.6909 6.21178ZM9.29096 6.17951L9.03633 15.5418C9.02799 15.8459 9.24923 16.0996 9.53029 16.1084C9.81137 16.1174 10.0458 15.8781 10.0541 15.5741L10.3087 6.21176C10.3169 5.9077 10.0958 5.65396 9.81473 5.64516C9.53366 5.63613 9.29909 5.87546 9.29096 6.17951ZM5.31773 2.34047H8.68177C8.75385 2.34047 8.79523 2.28208 8.77623 2.21005L8.66845 1.80169C8.61163 1.58676 8.35417 1.37682 8.14731 1.37682H5.85219C5.64534 1.37682 5.38787 1.58695 5.33105 1.80169L5.22328 2.21005C5.2041 2.28285 5.24653 2.34047 5.31773 2.34047Z"
                                    fill="white"
                                  />
                                </svg>
                              </i>
                            </div>

                            <div
                              class="file-note-text mt-1"
                              v-if="!documentFileErr && !documentFile.img"
                            >
                              <b>{{ $t("common.notes.note") }}: </b>{{ $t("common.notes.uploadImgNoteDoc") }}
                            </div>
                            <p
                              class="file-err-text mt-1"
                              v-if="documentFileErr"
                            >
                              <b>{{ $t("common.notes.note") }}: </b>{{ $t("common.notes.uploadImgNoteDoc") }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <p @click="onQrCodeRemove()" class="text-center"></p>
                      </div>
                    </div>
                  </div>
                  <!-- pcr data  -->
                  <div
                    v-if="form.vaccine_pcr == 'pcr'"
                    class="pcr-inputs-wrapperr"
                  >
                    <div v-if="!pcrQrScan">
                      <div class="vaccine-type">
                        <div class="vaccine-typecon"></div>
                        <div class="vaccine-closing"></div>
                      </div>
                      <div style="position: relative" class="text-center">
                        <!-- #PCR QR SCAN INPUT -->
                        <!-- <div> <i class="mdi mdi-qrcode-scan mdi-24px scan-icon"></i></div>
                    <button class="scan-btn" @click="$bvModal.show('scanQrModal')">Scan PCR QR Code</button>
                    <p class="modal-optional-text">Or add PCR details manually</p>
                  </div> -->

                        <!-- result  -->
                        <b-form-group>
                          <multiselect
                            id="result"
                            :class="{
                              'is-invalid invalid-select-input':
                                submitted &&
                                $v.pcr.pcr_result.$error &&
                                form.vaccine_pcr == 'pcr',
                            }"
                            v-model="pcr.pcr_result"
                            :options="pcrResultOptions"
                            :placeholder="$t('signInOut.pcrResult')"
                            :show-labels="false"
                            label="name"
                            :allowEmpty="true"
                            @input="checkExpired()"
                          />
                          <!-- <div
                      v-if="
                        submitted &&
                        !$v.pcr.pcr_result.required &&
                        form.vaccine_pcr == 'pcr'
                      "
                      class="invalid-feedback"
                    >
                      PCR result is required.
                    </div> -->
                        </b-form-group>
                        <!-- pcr date  -->

                        <div class="d-flex justify-content-between">
                          <b-form-group>
                            <date-picker
                              id="pcr_date"
                              v-model="pcr.pcr_date"
                              class="pcr-datepicker"
                              :class="{
                                'is-invalid invalid-date-input':
                                  submitted &&
                                  $v.pcr.pcr_date.$error &&
                                  form.vaccine_pcr == 'pcr',
                              }"
                              :first-day-of-week="1"
                              :placeholder="$t('common.doc.dateTaken')"
                              value-type="format"
                              format="DD/MM/YYYY"
                              :disabledDate="disableDateAfterCurrent"
                            >
                              <i slot="icon-calendar" v-if="!pcr.pcr_date">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                                    fill="#787878"
                                  />
                                </svg>
                              </i>
                              <i slot="icon-calendar" v-if="pcr.pcr_date">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                                    fill="#103F5E"
                                  />
                                </svg> </i
                            ></date-picker>
                            <!-- <div
                        v-if="
                          submitted &&
                          !$v.pcr.pcr_date.required &&
                          form.vaccine_pcr == 'pcr'
                        "
                        class="invalid-feedback"
                      >
                        PCR date is required.
                      </div> -->
                          </b-form-group>

                          <!-- PCR File (upload) -->
                          <div class="mb-3">
                            <div>
                              <button
                                type="button"
                                @click="pickImage"
                                class="upload-btn"
                                :class="{
                                  'file-validation': pcrFileErr && !pcrFile.img,
                                }"
                              >
                                <b-form-file
                                  accept="image/*"
                                  id="imagePicker"
                                  @change="onFileChange"
                                  v-model="pcr.pcr_document"
                                  class="d-none upload-btn"
                                ></b-form-file>
                                <div
                                  class="d-flex justify-content-between w-25"
                                >
                                  <p
                                    class="mt-3 file-label"
                                    :class="{
                                      'file-label-img-selected': pcrFile.img,
                                    }"
                                  >
                                    {{$t('signInOut.pcrFile')}}
                                  </p>
                                  <span
                                    class="mt-2 paperclip-icon"
                                    v-if="!pcrFile.img"
                                    ><i class="mdi mdi-paperclip mdi-24px"></i
                                  ></span>
                                </div>
                              </button>
                              <div
                                v-if="pcrFile.img"
                                style="position: relative"
                              >
                                <img
                                  :class="{
                                    'img-bg':
                                      onlineCompliance &&
                                      data.originalPivot.length != 0,
                                    'img-file':
                                      !onlineCompliance ||
                                      data.originalPivot.length == 0,
                                  }"
                                  :src="pcrFile.img"
                                />
                                <i
                                  @click="removePcrImage()"
                                  class="mdi-24px remove-file-icon"
                                  style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                  "
                                >
                                  <svg
                                    width="14"
                                    height="19"
                                    viewBox="0 0 14 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M13.3636 2.34047C13.715 2.34047 14 2.64876 14 3.02888C14 3.40919 13.715 3.71728 13.3636 3.71728H13.3548C13.2844 3.71728 13.2253 3.7776 13.2227 3.85558L12.7646 17.2377C12.731 18.2146 11.9762 19 11.0728 19H2.92723C2.02345 19 1.26904 18.2133 1.23544 17.2377L0.777349 3.85558C0.774686 3.77932 0.717158 3.71728 0.645248 3.71728H0.63637C0.28498 3.71728 0 3.40919 0 3.02888C0 2.64876 0.28498 2.34047 0.63637 2.34047H3.73886C3.80881 2.34047 3.88143 2.28035 3.90026 2.20909L4.10764 1.42347C4.32054 0.617499 5.07747 0 5.85253 0H8.14764C8.92269 0 9.67943 0.617352 9.89252 1.42347L10.0999 2.20909C10.1191 2.2817 10.1906 2.34047 10.2613 2.34047H13.3636ZM6.49084 6.19564V15.558C6.49084 15.8622 6.71864 16.1086 6.99989 16.1086C7.28113 16.1086 7.50894 15.8622 7.50894 15.558V6.19564C7.50894 5.89139 7.28113 5.64497 6.99989 5.64497C6.71864 5.64497 6.49084 5.8914 6.49084 6.19564ZM3.6909 6.21178L3.94552 15.5741C3.95387 15.8781 4.18824 16.1175 4.4693 16.1084C4.75037 16.0996 4.97162 15.8459 4.96326 15.5418L4.70864 6.17952C4.70047 5.87546 4.46592 5.63612 4.18486 5.64517C3.90378 5.654 3.68272 5.90774 3.6909 6.21178ZM9.29096 6.17951L9.03633 15.5418C9.02799 15.8459 9.24923 16.0996 9.53029 16.1084C9.81137 16.1174 10.0458 15.8781 10.0541 15.5741L10.3087 6.21176C10.3169 5.9077 10.0958 5.65396 9.81473 5.64516C9.53366 5.63613 9.29909 5.87546 9.29096 6.17951ZM5.31773 2.34047H8.68177C8.75385 2.34047 8.79523 2.28208 8.77623 2.21005L8.66845 1.80169C8.61163 1.58676 8.35417 1.37682 8.14731 1.37682H5.85219C5.64534 1.37682 5.38787 1.58695 5.33105 1.80169L5.22328 2.21005C5.2041 2.28285 5.24653 2.34047 5.31773 2.34047Z"
                                      fill="white"
                                    />
                                  </svg>
                                </i>
                              </div>

                              <div
                                class="file-note-text mt-1"
                                v-if="!pcrFileErr && !pcrFile.img"
                              >
                                <b>{{ $t("common.notes.note") }}: </b>{{ $t("common.notes.uploadImgNoteDoc") }}
                              </div>
                              <p class="file-err-text mt-1" v-if="pcrFileErr">
                                <b>{{ $t("common.notes.note") }}: </b>{{ $t("common.notes.uploadImgNoteDoc") }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <p @click="onQrCodeRemove"></p>
                    </div>
                  </div>
                </template>
                <!-- document notes  -->
                <div>
                  <b-form-group>
                    <b-form-textarea
                      id="notes"
                      class="form-control visitNotesText"
                      v-model="form.notes"
                      type="text"
                      :placeholder="$t('common.doc.documentNotes') + ' ' + $t('common.optionalWithBrackets')"
                      rows="3"
                      no-resize
                      maxlength="255"
                    ></b-form-textarea>
                  </b-form-group>
                  
                  <hr class="vertical-line" style="margin: 30px auto 19px auto;" />
                </div>
              </template>

              <template
                v-if="onlineCompliance && data.originalPivot.length != 0"
              >
                <div class="vaccine-answers-cont">
                  <p class="questions">
                    {{
                      form.vaccine_pcr == "vaccine"
                        ? $t("common.doc.vaccineProtocol")
                        : $t("signInOut.pcrResult")
                    }}
                  </p>
                  <p class="answers">
                    {{
                      form.vaccine_pcr == "vaccine"
                        ? vaccine.vaccine_protocol
                        : pcr.pcr_result.name
                    }}
                  </p>
                  <div class="sep-between-quessions"></div>
                  <p class="questions" v-if="form.vaccine_pcr == 'vaccine'">
                    {{ $t("common.doc.vaccineName") }}
                  </p>
                  <p class="answers" v-if="form.vaccine_pcr == 'vaccine'">
                    {{ vaccine.vaccine_name }}
                  </p>
                  <div
                    class="sep-between-quessions"
                    v-if="
                      form.vaccine_pcr == 'vaccine' && vaccine.vaccine_number
                    "
                  ></div>
                  <p
                    class="questions"
                    v-if="
                      form.vaccine_pcr == 'vaccine' && vaccine.vaccine_number
                    "
                  >
                    {{ $t("common.doc.batchNumber") }}
                  </p>
                  <p
                    class="answers"
                    v-if="
                      form.vaccine_pcr == 'vaccine' && vaccine.vaccine_number
                    "
                  >
                    {{ vaccine.vaccine_number }}
                  </p>
                  <div class="sep-between-quessions"></div>
                  <p class="questions">{{ $t("common.doc.dateTaken") }}</p>
                  <p class="answers">
                    {{
                      form.vaccine_pcr == "vaccine"
                        ? vaccine.vaccine_given_date
                        : getDay(pcr.pcr_date)
                    }}
                  </p>
                  <div class="sep-between-quessions"></div>
                  <p
                    class="questions"
                    v-if="
                      form.vaccine_pcr == 'vaccine' &&
                      vaccine.vaccine_expire_date
                    "
                  >
                    {{ $t("common.doc.expiryDate") }}
                  </p>
                  <p
                    class="answers"
                    v-if="
                      form.vaccine_pcr == 'vaccine' &&
                      vaccine.vaccine_expire_date
                    "
                  >
                    {{ vaccine.vaccine_expire_date }}
                  </p>
                  <div
                    v-if="
                      (documentFile && documentFile.img) ||
                      (pcrFile && pcrFile.img)
                    "
                    class="sep-between-quessions"
                  ></div>
                  <p
                    class="questions"
                    v-if="
                      (documentFile && documentFile.img) ||
                      (pcrFile && pcrFile.img)
                    "
                  >
                    {{
                      form.vaccine_pcr == "vaccine"
                        ? $t("signInOut.vaccineFile")
                        : $t("signInOut.pcrFile")
                    }}
                  </p>
                  <div
                    v-viewer
                    class="images dash-img clearfix"
                    v-if="
                      (documentFile && documentFile.img) ||
                      (pcrFile && pcrFile.img)
                    "
                  >
                    <img
                      style="cursor: pointer"
                      class="img-bg"
                      :src="
                        form.vaccine_pcr == 'vaccine'
                          ? documentFile.img
                          : pcrFile.img
                      "
                    />
                  </div>
                </div>
              </template>
            </div>

            <!-- Agreement || Questionnaire -->
            <template v-else>
              
              <div
                class="facemask-questioncon"
                v-for="(question, i) in data.form_metadata.questions"
                :key="'question' + i"
              >
                <p class="facemask">
                  {{ question.type == "questionnaire" ? i + 1 + "-" : "" }}
                  <template v-if="question.content_type == 'IMAGE'">
                    <div class="img-agr">
                      <img v-viewer :src="question.attachment_url" class="cursor-zoomin thumbnail-image" />
                    </div>
                  </template>

                  <template v-else-if="question.content_type == 'PDF'">
                    <div class="pdf-agr">
                      <div class="d-flex align-items-center justify-content-between" style="padding: 20px 20px 0 24px;">
                        <span class="d-flex align-items-center justify-content-center cursor-pointer" @click="openPDF(question.attachment_url)">{{ getPDFName(question.attachment_url) }}</span>
                        <svg class="cursor-pointer" @click="openPDF(question.attachment_url)" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0864 0C14.5903 4.31018e-08 14.9987 0.415294 14.9987 0.927585L14.9987 4.86299C14.9987 5.37528 14.5903 5.79058 14.0864 5.79058C13.5826 5.79058 13.1741 5.37528 13.1741 4.86299V3.16697L9.89333 6.50274C9.53706 6.86499 8.95942 6.86499 8.60314 6.50274C8.24687 6.1405 8.24687 5.55319 8.60314 5.19094L11.884 1.85517L10.2159 1.85517C9.71203 1.85517 9.30358 1.43988 9.30358 0.927584C9.30358 0.415294 9.71203 4.91633e-08 10.2159 6.22367e-09L14.0864 0Z" fill="#103F5E"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3.77216C0 2.08096 1.3484 0.709961 3.01174 0.709961H6.52544C7.07989 0.709961 7.52936 1.16696 7.52936 1.73069C7.52936 2.29443 7.07989 2.75143 6.52544 2.75143H3.01174C2.4573 2.75143 2.00783 3.20843 2.00783 3.77216V11.938C2.00783 12.5018 2.4573 12.9588 3.01174 12.9588H11.0431C11.5975 12.9588 12.047 12.5018 12.047 11.938V8.36546C12.047 7.80173 12.4964 7.34473 13.0509 7.34473C13.6053 7.34473 14.0548 7.80173 14.0548 8.36546V11.938C14.0548 13.6292 12.7064 15.0002 11.0431 15.0002H3.01174C1.3484 15.0002 0 13.6292 0 11.938V3.77216Z" fill="#103F5E"/>
                        </svg>
                      </div>
                      <hr style="border-top: 1px solid #C8C0C0; margin: 20px 0 0 0;">
                      <iframe 
                      class="iframe-container"
                        :src="question.attachment_url + '#toolbar=0&navpanes=0&scrollbar=0'" 
                        width="100%" 
                        height="483px" 
                        style="border:none;">
                      </iframe>
                    </div>
                  </template>

                  <template v-else>{{ question.body }}</template>
                </p>

                <div class="radios-container">
                  <v-radio-group :class="{'radio-disabled': onlineCompliance && data.pivot?.action_by}" v-model="question.pivot.answer.text">
                  <v-radio
                    @change="cc(question, JSON.parse(question.answers[0].desired), 0)"
                    :value="question.answers[0].text"
                    :label="question.answers[0].text"
                    :color="((!onlineCompliance && (!data.notes || data.notes?.length < 20)) || (onlineCompliance && data.pivot?.action_by && data.pivot?.action_by.toLowerCase() == 'user')) && JSON.parse(question.answers[0].desired) == false && question.answers[0].text == question.pivot.answer.text ? '#F46A6A'
                    : (!onlineCompliance || (onlineCompliance && data.pivot?.action_by)) &&JSON.parse(question.answers[0].desired) == true && question.answers[0].text == question.pivot.answer.text ? '#34C38F' : '#103F5E'"
                    :class="{
                            'text-success': (!onlineCompliance || (onlineCompliance && data.pivot?.action_by)) &&JSON.parse(question.answers[0].desired) == true && question.answers[0].text == question.pivot.answer.text,
                            'text-danger': ((!onlineCompliance && (!data.notes || data.notes?.length < 20))  || (onlineCompliance && data.pivot?.action_by && data.pivot?.action_by.toLowerCase() == 'user')) && JSON.parse(question.answers[0].desired) == false && question.answers[0].text == question.pivot.answer.text,
                            'radio-disabled-with-opacity': onlineCompliance && data.pivot?.action_by && question.answers[0].text != question.pivot.answer.text,
                          }"
                  >
                  </v-radio>
                  <span class="response-err response-err-danger" v-if="!onlineCompliance && (!data.notes || data.notes?.length < 20) && JSON.parse(question.answers[0].desired) == false && question.answers[0].text == question.pivot.answer.text">{{ $t("signInOut.responseNotMeet") }} {{ $tc("signInOut.responseWithJustification", 1)}}</span>
                  <span class="response-err" v-else-if="data.notes?.length >= 20 && JSON.parse(question.answers[0].desired) == false && question.answers[0].text == question.pivot.answer.text">{{ onlineCompliance ? `${$t("complianceList.justificationProvided")}` : (`${$t("signInOut.responseNotMeet")} ${$tc("signInOut.responseWithJustification", 2)}`) }}</span>

                  <v-radio
                    @change="cc(question, JSON.parse(question.answers[1].desired), 1)"
                    :value="question.answers[1].text"
                    :label="question.answers[1].text"
                    :color="((!onlineCompliance && (!data.notes || data.notes?.length < 20)) || (onlineCompliance && data.pivot?.action_by && data.pivot?.action_by.toLowerCase() == 'user')) && JSON.parse(question.answers[1].desired) == false && question.answers[1].text == question.pivot.answer.text ? '#F46A6A'
                    : (!onlineCompliance || (onlineCompliance && data.pivot?.action_by)) &&JSON.parse(question.answers[1].desired) == true && question.answers[1].text == question.pivot.answer.text ? '#34C38F' : '#103F5E'"
                    :class="{
                            'text-success': (!onlineCompliance || (onlineCompliance && data.pivot?.action_by)) &&JSON.parse(question.answers[1].desired) == true && question.answers[1].text == question.pivot.answer.text,
                            'text-danger':((!onlineCompliance && (!data.notes || data.notes?.length < 20)) || (onlineCompliance && data.pivot?.action_by && data.pivot?.action_by.toLowerCase() == 'user')) && JSON.parse(question.answers[1].desired) == false && question.answers[1].text == question.pivot.answer.text,
                            'radio-disabled-with-opacity': onlineCompliance && data.pivot?.action_by && question.answers[1].text != question.pivot.answer.text,
                          }"
                  >
                  </v-radio>
                  <span class="response-err response-err-danger" v-if="!onlineCompliance && (!data.notes || data.notes?.length < 20) && JSON.parse(question.answers[1].desired) == false && question.answers[1].text == question.pivot.answer.text">{{ $t("signInOut.responseNotMeet") }} {{ $tc("signInOut.responseWithJustification", 1)}}</span>
                  <span class="response-err" v-else-if="data.notes?.length >= 20 && JSON.parse(question.answers[1].desired) == false && question.answers[1].text == question.pivot.answer.text">{{ onlineCompliance ? `${$t("complianceList.justificationProvided")}` : (`${$t("signInOut.responseNotMeet")} ${$tc("signInOut.responseWithJustification", 2)}`) }}</span>
                </v-radio-group>

                <hr v-if="i != data.form_metadata.questions.length - 1 || !onlineCompliance" class="vertical-line" style="margin: 24px auto;" />
<!-- {{question.pivot.answer.yesAnswer}} -->
                  <!-- <v-radio-group v-model="question.pivot.answer.yesAnswer">
                    <v-radio
                      v-for="(answer, index2) in question.answers"
                      :key="'answer' + index2"
                      @change="cc(question, answer.desired, answer.text)"
                      :color="
                        data.pivot && data.pivot.action_by && onlineCompliance
                          ? answer.yesAnswer == true &&
                            question.pivot.answer.yesAnswer == 'true'
                            ? '#34C38F'
                            : '#F46A6A'
                          : '#103f5e'
                      "
                      :class="{
                        'text-success':
                          data.pivot &&
                          data.pivot.action_by &&
                          onlineCompliance &&
                          answer.yesAnswer == true &&
                          question.pivot.answer.yesAnswer == 'true',
                        'text-danger':
                          data.pivot &&
                          data.pivot.action_by &&
                          onlineCompliance &&
                          answer.yesAnswer == false &&
                          question.pivot.answer.yesAnswer == 'false',
                      }"
                      :label="answer.text"
                      :value="answer.yesAnswer == true ? 'true' : 'false'"
                      :disabled="
                        data.pivot &&
                        data.pivot.action_by &&
                        onlineCompliance &&
                        !(
                          (answer.yesAnswer == true &&
                            question.pivot.answer.yesAnswer == 'true') ||
                          (answer.yesAnswer == false &&
                            question.pivot.answer.yesAnswer == 'false')
                        )
                      "
                    ></v-radio>

                    <hr v-if="i != data.form_metadata.questions.length" class="vertical-line" style="margin: 0 auto 19px auto;" />
                  </v-radio-group> -->
                </div>
              </div>
            </template>

            <!-- <div
              v-if="!onlineCompliance"
              class="notes-form text-center"
              style="padding-inline-start: 0"
            > -->
            <template v-if="!onlineCompliance">
              
            
            <span
              class="compliance-note-label"
              v-if="data.notes?.length"
              >{{ $tc("signInOut.complianceNote", 1) }} {{ (isNotesOptional
                && (!data.isDue || (data.pivot?.metadata &&data.pivot?.metadata[0] && data.pivot?.metadata[0].actionBy)
                || data.pivot?.metadata?.actionBy)) ? $t("common.optionalWithBrackets") : "" }}</span
            >
              <b-form-textarea
                id="notesTextarea"
                v-model="data.notes"
                :class="{
                  'remove-padding':
                    data.notes?.length && showNotesLabel,
                  'top-padding': data.notes?.length && !showNotesLabel,
                  'has-value': data.notes?.length
                }"
                class="note-textarea form-control"
                rows="4"
                no-resize
                maxlength="255"
                :placeholder="$tc('signInOut.complianceNote', 1) + ' ' + ((isNotesOptional
                && (!data.isDue || (data.isDue && data.pivot?.metadata && data.pivot?.metadata[0] && data.pivot?.metadata[0].actionBy)
                || data.pivot?.metadata?.actionBy)) ? $t('common.optionalWithBrackets') : '')"
                @keyup="cc()"
              ></b-form-textarea>
              
              <p v-if="data.isDue && !((data.pivot?.metadata && data.pivot?.metadata[0] && data.pivot?.metadata[0].actionBy)
                || data.pivot?.metadata?.actionBy)" class="compfillin-note"><b>{{ $t("common.notes.note") }}:</b> {{ $t("common.notes.compNotes") }}</p>

              <p v-else-if="!isNotesOptional" class="compfillin-note">
                <b>{{ $t("common.notes.note") }}:</b> {{ $t("signInOut.mandatoryNotes") }}
              </p>
            </template>
            <!-- </div> -->
            <!-- <div
              v-if="data.pivot && data.pivot.action_by && onlineCompliance"
              class="diffrentactions-btns d-flex align-items-center justify-content-center"
            >
              <b-button
                variant="primary"
                type="button"
                pill
                class="text-center custom-backBtn"
                @click="navigateToTab"
              >
                <span
                  ><svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.4614 12.4355H9.73118L16.0378 6.12886L14.4358 4.53809L5.41016 13.5637L14.4358 22.5894L16.0266 20.9986L9.73118 14.6919H23.4614V12.4355Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <span style="margin-inline-start: 13px">{{ $t("common.back").toUpperCase() }}</span>
              </b-button>
            </div> -->

            <div
              class="diffrentactions-btns d-flex align-items-center justify-content-center"
            >
              <b-button
                @click="navigateToTab"
                variant="primary"
                type="button"
                pill
                class="text-center custom-back"
              >
                <span
                  ><svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.4614 12.4355H9.73118L16.0378 6.12886L14.4358 4.53809L5.41016 13.5637L14.4358 22.5894L16.0266 20.9986L9.73118 14.6919H23.4614V12.4355Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </b-button>
            </div>
              <hr v-if="!onlineCompliance" class="vertical-line" style="margin: 40px auto 24px auto;" />

              <div class="modal-actions-btns" style="width: 416px">
                <VpButton
                  v-if="!onlineCompliance || (!(data.pivot && data.pivot.action_by) && onlineCompliance)"
                  :text="onlineCompliance ? $t('common.submit').toUpperCase() : $t('common.submit')"
                  @click="submitForm()"
                  :disabled="
                    checkValidation
                      ? true
                      : false ||
                        $v.data.notes.$invalid || //checks if compliance is 'isDue'
                        (data.type == 'vaccine_document' &&
                          !form.document &&
                          ($v.$invalid ||
                            (is_expired &&
                              data.notes &&
                              data.notes?.length < 20 &&
                              !onlineCompliance))) ||
                        (form.document &&
                          form.document.is_expired &&
                          data.notes &&
                          data.notes?.length < 20 &&
                          !onlineCompliance) ||
                        isLoading
                  "
                  :isLoading="isLoading"
                  :width="onlineCompliance ? '416px' : '112px'"
                  :height="onlineCompliance ? '44px' : '32px'"
                  :fontWeight="onlineCompliance ? '700' : '400'"
                  :style="onlineCompliance && !(data.pivot && data.pivot.action_by) ? 'margin-top: 40px' : ''"
                />

                <VpButton
                  v-if="!onlineCompliance"
                  :text="$t('common.cancel')"
                  :disabled="isLoading"
                  :isDanger="true"
                  @click="hideModals"
                />
              </div>
          </template>
        </div>
      </tab-content>

      <tab-content v-if="rejectClicked || approveClicked">
        <div class="visit-permission">
          <p>
            {{ $t("common.notes.areYouSureYouWant") }}<strong class="strong-txt">
              “{{ rejectClicked ? $t("common.reject") : $t("common.approve") }}”</strong
            >
            {{ $t("complianceList.thisVisitRequestOf") }} {{ firstName + " " + lastName }}?
          </p>
          <template v-if="rejectClicked">
            <p class="reason-txt">{{ $t("common.notes.ifYesPleaseSpecifyTheReason") }}</p>
            <b-form-textarea
              id="rejectTextarea"
              class="form-control visitNotesText"
              rows="5"
              :placeholder="$t('common.reason')"
              maxlength="255"
              v-model="reason"
            ></b-form-textarea>
          </template>
        </div>
        <hr class="vertical-line" />
        <div class="modal-actions-btns">
          <VpButton
            :text="$t('common.back')"
            @click="
              approveClicked = false;
              rejectClicked = false;
              setApproveVisit(false);
              setRejectVisit(false);
            "
          />

          <VpButton
            v-if="rejectClicked"
            :text="$t('common.reject')"
            @click="approveOrRejectVisit(0)"
            :disabled="!reason || isLoading"
            :isLoading="isLoading"
            :isDanger="true"
          />

          <VpButton
            v-if="approveClicked"
            :text="$t('common.approve')"
            @click="approveOrRejectVisit(1)"
            :isOutline="true"
            :disabled="isLoading"
            :isLoading="isLoading"
          />
        </div>
      </tab-content>

      <span slot="back"></span>
      <span slot="next"></span>
      <span slot="finish"></span>
    </Form-wizard>
  </div>
</template>

<script>
// import Qrscan from './Qrscan.vue'
import moment from "moment";
import { layoutComputed } from "@/state/helpers";
import { mapActions, mapGetters } from "vuex";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { requiredIf } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import ShowDocumentDetails from "../reports/showDocumentDetails/showDocumentDetails.vue";
// eslint-disable-next-line no-unused-vars
import { upperFirst } from "lodash";
//Validation to check if compliance is due && check notes length (>=20)
const customIfRequiredMinimumLength = (notes, data) => {
  if (data?.isDue && notes?.length < 20) return false;
  return true;
};

export default {
  page: {
    title: "Pre-Registration form",
  },
  name: "PreRegistrationForm",
  components: {
    FormWizard,
    TabContent,
    Multiselect,
    DatePicker,
    ShowDocumentDetails,
  },
  props: [
    "modalId",
    "modalLoading",
    "visitId",
    "firstName",
    "lastName",
    "journeyLogo",
    "id",
    "manageVisit",
    "visitRejected",
    "visitApproved",
    "action_by",
    "scan_time",
    "rejectionReason",
    "userTypeId",
    "areaId",
    "onlineCompliance",
    "siteName",
    "areaName",
    "userTypeForUser",
    "visitDate",
    "visitTime",
    "registrationMethod",
    "journeyStage",
  ],
  data() {
    return {
      logoStyle: {
        width: '110px',
        height: 'auto',
      },
      showScreen: false,
      documentDetails: {},
      showNotesLabel: true,
      vaccineUploadedImg: "",
      pcrUploadedImg: "",
      vaccineQrScan: false,
      pcrQrScan: false,
      isPcrEnabled: null,
      allUserCompliance: [],
      data: null,
      compExists: null,
      approveClicked: false,
      rejectClicked: false,
      reason: "",
      isLoading: false,
      is_expired: false,
      vaccinePcrOptions: [
        { text: "Vaccine", value: "vaccine_document" },
        { text: "Pcr", value: "pcr" },
      ],
      protocolsOptions: [
        "EU Digital COVID Certificate",
        "NHS (Domestic/International)",
        "Smart Health Card (SHC)",
        "NYS Excelsior Pass & NYS Excelsior Pass Plus",
      ],
      pcrFileErr: false,
      documentFileErr: false,
      isDocumentFileRemoved: false,
      documentFile: {
        img: "",
      },
      pcrFile: {
        img: "",
      },
      pcrFileImageChanged: null,
      pcrFileImage: null,
      isPcrFileRemoved: false,
      form: {
        document: null,
        vaccine_pcr: "vaccine",
        notes: "",
      },
      vaccine: {
        vaccine_name: null,
        vaccine_number: null,
        vaccine_given_date: null,
        vaccine_expire_date: null,
        flow_has_vaccien: null,
        documentOptions: [],
        vaccine_protocol: null,
        vaccine_document: null,
      },
      pcr: {
        pcr_result: null,
        pcr_date: null,
        pcr_document: null,
      },
      pcrResultOptions: [
        {
          id: "positive",
          name: "Positive PCR",
        },
        {
          id: "negative",
          name: "Negative PCR",
        },
      ],
      submitted: false,
    };
  },
  validations: {
    data: {
      notes: {
        customIfRequiredMinimumLength,
      },
    },
    vaccine: {
      vaccine_name: {
        required: requiredIf(function () {
          return this.form.vaccine_pcr === "vaccine" && !this.form.document;
        }),
      },
      vaccine_given_date: {
        required: requiredIf(function () {
          return this.form.vaccine_pcr === "vaccine" && !this.form.document;
        }),
      },
      vaccine_expire_date: {
        required: requiredIf(function () {
          return this.form.vaccine_pcr === "vaccine" && !this.form.document;
        }),
      },
      vaccine_protocol: {
        required: requiredIf(function () {
          return this.form.vaccine_pcr === "vaccine" && !this.form.document;
        }),
      },
      vaccine_document: {
        required: requiredIf(function () {
          return this.form.vaccine_pcr === "vaccine" && !this.form.document;
        }),
      },
    },
    pcr: {
      pcr_result: {
        mustBeNegative: function (pcrResult) {
          if (this.form.vaccine_pcr === "pcr" && !this.onlineCompliance) {
            return (
              (pcrResult?.id == "positive" && this.data?.notes?.length >= 20) ||
              pcrResult?.id === "negative"
            );
          }
          return true;
        },
        required: requiredIf(function () {
          return this.form.vaccine_pcr === "pcr";
        }),
      },
      pcr_date: {
        required: requiredIf(function () {
          return this.form.vaccine_pcr === "pcr";
        }),
      },
      pcr_document: {
        required: requiredIf(function () {
          return this.form.vaccine_pcr === "pcr";
        }),
      },
    },
  },
  watch: {
    "form.document": function (document) {
      if (document && Object.keys(document)?.length) {
        this.updateDocumentDetails(document);
      }
    },
    getAreaDocuments(documents) {
      let documentOptions = [];
      // console.log("watch getAreaDocuments", documents);
      const { flow_has_vaccien, user_documents, complianceDocument } =
        documents;
      this.vaccine.flow_has_vaccien = flow_has_vaccien;

      this.isPcrEnabled = complianceDocument[0]?.form_metadata?.data[0]?.pcr
        ? true
        : false;

      //Filter document if pcr is disabled
      if (user_documents?.length && !this.isPcrEnabled) {
        console.log("vaccine only");
        documentOptions = user_documents.filter(
          (item) => item.type == "covid_vaccine"
        );
      } else {
        console.log("All docs");
        documentOptions = user_documents;
      }

      this.vaccine.documentOptions = documentOptions.map((item) => {
        // console.log('item', item);
        const metadata =
          typeof item.metadata == "object"
            ? item.metadata
            : JSON.parse(item.metadata);

        if (item.type == "covid_pcr") {
          // const {
          //   metadata: {
          //     certificateModel: { tests },
          //   },
          // } = item;
          return {
            id: item.id,
            name:
              metadata.tests && metadata.tests[0].testResult == "Not detected"
                ? "Negative PCR"
                : "Positive PCR",
            date: metadata.tests && metadata.tests[0].dateTimeOfTestResult,
            value: `${
              metadata.tests && metadata.tests[0].testResult == "Not detected"
                ? "Negative PCR"
                : "Positive PCR"
            }  (${moment(
              metadata.tests && metadata.tests[0].dateTimeOfTestResult
            ).format("DD/MM/YYYY")})`,
            is_expired:
              metadata.tests && metadata.tests[0].testResult == "Not detected"
                ? true
                : false,
            ...item,
          };
        } else if (item.type == "covid_vaccine") {
          // const {
          //   metadata: {
          //     certificateModel: { vaccinations },
          //     greenCertificatData: { expirationTime },
          //   },
          // } = item;

          return {
            id: item.id,
            name:
              metadata.vaccinations &&
              metadata.vaccinations[0].vaccine &&
              metadata.vaccinations[0].vaccine.length
                ? metadata.vaccinations[0].vaccine
                : "Vaccine",
            date: metadata.expirationTime,
            value: `${
              metadata.vaccinations &&
              metadata.vaccinations[0].vaccine &&
              metadata.vaccinations[0].vaccine.length
                ? metadata.vaccinations[0].vaccine
                : "Vaccine"
            }  (${moment(metadata.expirationTime).format("DD/MM/YYYY")})`,
            is_expired: item.is_expiry,
            ...item,
          };
        }
      });
      // console.log("this.vaccine.documentOptions", this.vaccine.documentOptions);
    },

    getUserCompliance(userCompliance) {
      console.log("watch usercomp", userCompliance);
      this.compExists = userCompliance && userCompliance.length > 0;
      // this.allUserCompliance = JSON.parse(JSON.stringify(userCompliance));

      // this.allUserCompliance.map((item) => {
      //   item.notes =
      //     item.pivot && item.pivot.metadata ? item.pivot.metadata[0].notes : "";
      //   if (this.getStatus(item).id != 1) this.allAnswered = false;
      //   if (item.form_metadata.questions)
      //     item.form_metadata.questions.map((question) => {
      //       if (item.pivot && item.pivot.metadata) {
      //         // move user answer to the question
      //         const userAnswer = item.pivot.metadata.find(
      //           (metadata) => metadata.body == question.body
      //         );
      //         if (userAnswer) {
      //           question.pivot = userAnswer;
      //         } else {
      //           question.pivot = {
      //             answer: {
      //               yesAnswer: null,
      //               desired: null,
      //             },
      //           };
      //         }
      //       } else {
      //         question.pivot = {
      //           answer: {
      //             yesAnswer: null,
      //             desired: null,
      //           },
      //         };
      //       }
      //     });
      // });
      this.allUserComplianceFn();
      console.log("watch after", this.allUserCompliance);

      this.navigateToTab();
    },
    "data.notes"() {
      let textArea = document.querySelector(".note-textarea");
      this.showNotesLabel = textArea?.scrollHeight > textArea?.clientHeight + 3;
    },
  },
  beforeMount() {},
  mounted() {
    this.compExists =
      this.getUserCompliance && this.getUserCompliance.length > 0;
    this.allUserComplianceFn();
  },
  computed: {
    ...mapGetters("compliance", ["getUserCompliance", "getComplianceCreated"]),
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("sites", ["getAreaDocuments"]),
    ...layoutComputed,
    isNotesOptional() {
      let notesOpt = true;
      this.data.form_metadata.questions.forEach((question) => {
        const answerFound = question.answers.find(answer => answer.text == question.pivot?.answer?.text);
        if (answerFound && JSON.parse(answerFound.desired) == false) notesOpt = false;
      });
      return notesOpt;
    },
    mainMsg() {
      console.log("registrationMethod", this.registrationMethod);
      let msg = "";
      if (this.allOptional()) {
        msg += this.$t("complianceList.youAreadyToVisit", { siteName: this.siteName, areaName: this.areaName, userTypeForUser: this.userTypeForUser, visitDate: this.visitDate, visitTime: this.visitTime });
      } else {
        if (
          this.registrationMethod ==
            "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED" &&
          this.journeyStage == "ready_to_sign_in"
        )
          msg += `${this.$t("complianceList.approvedVisit")} `;
        if (
          (this.registrationMethod !=
            "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED" &&
            this.allPassed()) ||
          (this.registrationMethod ==
            "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED" &&
            this.journeyStage == "ready_to_sign_in")
        )
          msg += `${this.$t("complianceList.youAreReady")} `;
        else if (
          this.registrationMethod !=
            "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED" &&
          this.allNotPassed()
        )
          msg +=
            `${this.$t("complianceList.willNotBeAble")} `;
        else if (
          this.registrationMethod ==
            "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED" &&
          this.allCompleted() &&
          this.journeyStage != "ready_to_sign_in"
        )
          msg += `${this.$t("complianceList.youllBeReady")} `;
        else msg += `${this.$t("complianceList.youAreExpected")} `;
        msg += this.$t("complianceList.toVisit", { siteName: this.siteName, areaName: this.areaName, userTypeForUser: this.userTypeForUser, visitDate: this.visitDate, visitTime: this.visitTime });
        if (
          this.registrationMethod ==
            "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED" &&
          this.allCompleted() &&
          this.journeyStage != "ready_to_sign_in"
        )
          msg += ` ${this.$t("complianceList.once")}`;
        else msg += ".";
        if (
          this.allNotFilled() &&
          this.registrationMethod !=
            "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED" &&
          !this.allNotPassed()
        )
          msg += ` ${this.$t("complianceList.pleaseMakeSure")}`;
        else if (
          this.allNotFilled() &&
          this.registrationMethod == "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED"
        )
          msg += ` ${this.$t("complianceList.pleaseMakeSure")}`;
      }
      return msg;
    },
    checkPassed() {
      let passed = true;
      // console.log("vvv", this.allUserCompliance);
      if (this.allUserCompliance)
        this.allUserCompliance.map((item) => {
          if (!this.getIsOptional(item) && this.getStatus(item).id != 1 && this.getStatus(item).id != 3) {
            passed = false;
          }
        });
      return passed;
    },
    checkValidation() {
      console.log("checkValidation", this.data);
      if (this.data.type == "vaccine_document") return false;
      const data =
        this.data.type == "vaccine_document" && data.form_metadata.data
          ? this.data.form_metadata.data
          : this.data.form_metadata.questions;
      const questionNotAnswered = data.find(
        (item) =>
          !item.pivot ||
          item.pivot.length == 0 ||
          item.pivot.answer.text == null
      );
      const answerNotPassed = data.find(
        (item) =>
          !item.pivot ||
          item.pivot.length == 0 ||
          !JSON.parse(item.pivot.answer.desired)
      );
      if (
        questionNotAnswered ||
        (answerNotPassed &&
          (!this.data.notes || this.data.notes.length < 20) &&
          !this.onlineCompliance)
      ) {
        console.log("disabled", questionNotAnswered, answerNotPassed);
        return true;
      }
      console.log("enabled");
      return false;
    },
  },
  methods: {
    ...mapActions("preRegistration", [
      "approveVisit",
      "rejectVisit",
      "approveRejectedVisit",
      "rejectApprovedVisit",
      "setApproveVisit",
      "setRejectVisit",
    ]),
    ...mapActions("compliance", [
      "createUserCompliance",
      "createUserOnlineCompliance",
      "checkIfStandalone",
    ]),
    openPDF(link) {
      window.open(link, "_blank");
    },
    getPDFName(link) {
      const fileNameWithExt = link.substring(link.lastIndexOf("/") + 1);
      const fileName = fileNameWithExt.replace(".pdf", "");
      return fileName;
    },
    adjustLogoSize() {
      this.$nextTick(() => {
        const logo = this.$refs.logo;

        if (logo) {
          const clone = logo.cloneNode(true);

          clone.style.position = 'absolute';
          clone.style.visibility = 'hidden';
          clone.style.width = '110px';
          clone.style.height = 'auto';

          document.body.appendChild(clone);

          // Ensure we measure only after the image has loaded
          clone.onload = () => {
            const measuredHeight = clone.offsetHeight;
            console.log("measuredHeight after setting width to (110px)", measuredHeight);
            document.body.removeChild(clone);

            const minHeight = 20;
            const maxHeight = 64;

            if (measuredHeight < minHeight) {
              this.logoStyle = { height: `${minHeight}px`, width: 'auto' };
            } else if (measuredHeight > maxHeight) {
              this.logoStyle = { height: `${maxHeight}px`, width: 'auto' };
            } else {
              this.logoStyle = { width: '110px', height: 'auto' };
            }

            this.showScreen = true;
          };
        } else if (!this.onlineCompliance || (this.onlineCompliance && !this.journeyLogo && !this.currentEntity.logo)) this.showScreen = true;
      });
    },
    hideModals() {
      this.$bvModal.hide(this.modalId);
      this.$bvModal.hide('visit_modal');
    },
    // onQrcodeScan(result){
    //   if(result){
    //     if(this.form.vaccine_pcr == "vaccine"){
    //       this.vaccineQrScan = true;
    //     }else{
    //       this.pcrQrScan = true;
    //     }
    //   }
    // },
    // onQrCodeRemove(){
    //   if(this.form.vaccine_pcr == "vaccine"){
    //     this.vaccineQrScan = false;
    //   }else{
    //     this.pcrQrScan = false;
    //   }
    // },
    updateVaccineProtocol() {
      this.$forceUpdate();
    },
    updateDocumentDetails(document) {
      console.log(document);

      const certificateModel = document?.metadata?.certificateModel;
      if (document.type == "covid_vaccine") {
        this.documentDetails = {
          "Vaccine Protocol":
            document?.metadata?.protocol != "manual"
              ? document?.metadata?.protocol
              : null,
          "Vaccine Name": certificateModel?.vaccinations[0]?.vaccine,
          "Batch Number": certificateModel?.vaccinations[0]?.batchNumber,
          "Date Taken": certificateModel?.vaccinations[0]?.dateOfVaccination
            ? moment(
                certificateModel.vaccinations[0].dateOfVaccination,
                "YYYY-MM-DD"
              ).format("DD/MM/YYYY")
            : null,
          "Expiry Date": moment(
            document.expiry_date,
            "YYYY-MM-DD hh:mm:ss"
          ).format("DD/MM/YYYY"),
          "Vaccine File": document.metadata.fileAttach,
        };
      } else if (document.type == "covid_pcr") {
        console.log(document);
        this.documentDetails = {
          "PCR Result": document.name,
          "Date Taken": certificateModel.tests[0]?.dateTimeOfTestResult
            ? moment(
                certificateModel.tests[0].dateTimeOfTestResult,
                "YYYY-MM-DD hh:mm:ss"
              ).format("DD/MM/YYYY")
            : null,
          "Vaccine File": document.metadata.fileAttach,
        };
      }
    },
    clearDocument() {
      this.form.document = null;
      this.vaccine.vaccine_name = null;
      this.vaccine.vaccine_protocol = null;
      this.vaccine.vaccine_document = null;
      this.vaccine.vaccine_expire_date = null;
      this.vaccine.vaccine_given_date = null;
      this.vaccine.vaccine_number = null;
      this.pcr.pcr_document = null;
      this.pcr.pcr_date = null;
      this.pcr.pcr_result = null;
      this.removePcrImage();
      this.removeImage();
    },
    pickImage() {
      document.getElementById("imagePicker").click();
    },
    onFileChange(e) {
      //Vaccine file
      if (this.form.vaccine_pcr == "vaccine") {
        this.documentFileErr = false;

        let file = e.target.files[0];
        if (!file || file.type.indexOf("image/") !== 0) return;

        const extensionType = file.type.split("/")[1];
        if (extensionType != "png" && extensionType != "jpeg") {
          return (this.documentFileErr = true);
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let newImg = new Image();
          newImg.onload = () => {
            if (file.size > 3097152) {
              return (this.documentFileErr = true);
            }
            this.documentFile.img = URL.createObjectURL(file);
            this.isDocumentFileRemoved = false;
          };
          newImg.src = evt.target.result;
          this.vaccineUploadedImg = file;
          this.vaccine.vaccine_document = file;
        };
        reader.onerror = (evt) => {
          console.error(evt);
        };
      } else {
        //PCR File
        this.pcrFileErr = false;

        let file = e.target.files[0];
        if (!file || file.type.indexOf("image/") !== 0) return;

        const extensionType = file.type.split("/")[1];
        if (extensionType != "png" && extensionType != "jpeg") {
          return (this.pcrFileErr = true);
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let newImg = new Image();
          newImg.onload = () => {
            if (file.size > 3097152) {
              return (this.pcrFileErr = true);
            }
            this.pcrFile.img = URL.createObjectURL(file);
            this.isPcrFileRemoved = false;
          };
          newImg.src = evt.target.result;
          this.pcrUploadedImg = file;
          this.pcr.pcr_document = file;
        };
        reader.onerror = (evt) => {
          console.error(evt);
        };
      }
    },
    removeImage() {
      this.documentFile.img = "";
      this.isDocumentFileRemoved = true;
      this.vaccine.vaccine_document = null;
    },
    removePcrImage() {
      this.pcrFile.img = "";
      this.isPcrFileRemoved = true;
      this.pcr.pcr_document = null;
    },
    allUserComplianceFn() {
      let allUserCompliance;
      if (this.getUserCompliance) {
        allUserCompliance = JSON.parse(JSON.stringify(this.getUserCompliance));
        this.adjustLogoSize();
      }

      // console.log('methoddddd', allUserCompliance);

      if (allUserCompliance)
        allUserCompliance.map((item) => {
          item.originalPivot = JSON.parse(JSON.stringify(item.pivot));
          item.notes = item.originalNotes =
            item.pivot && item.pivot.metadata
              ? item.pivot.metadata[0]
                ? item.pivot.metadata[0].notes
                : item.pivot.notes
                ? JSON.parse(item.pivot.notes).notes
                : ""
              : "";
          if (item.form_metadata.questions)
            item.form_metadata.questions.map((question) => {
              if (item.pivot && item.pivot.metadata && item.pivot.metadata[0]) {
                // move user answer to the question
                const userAnswer = item.pivot.metadata.find(
                  (metadata) => metadata.body == question.body
                );
                if (userAnswer) {
                  question.pivot = userAnswer;
                } else {
                  question.pivot = {
                    answer: {
                      yesAnswer: null,
                      desired: null,
                    },
                  };
                }
              } else {
                question.pivot = {
                  answer: {
                    yesAnswer: null,
                    desired: null,
                  },
                };
              }
            });
        });
      this.allUserCompliance = allUserCompliance;
    },
    allAnswered(compId) {
      let answered = true;
      this.allUserCompliance.map((item) => {
        if (
          item.id != compId &&
          !this.getIsOptional(item) &&
          this.getStatus(item).id == 0
        )
          answered = false;
      });
      return answered;
    },
    allCompleted() {
      // all answered including wrong answers
      let completed = true;
      this.allUserCompliance.map((item) => {
        if (!this.getIsOptional(item) && this.getStatus(item).id == 0)
          completed = false;
      });
      return completed;
    },
    allPassed() {
      // all answered && answered correctly
      let passed = true;
      this.allUserCompliance.map((item) => {
        if (
          !this.getIsOptional(item) &&
          (this.getStatus(item).id == 0 || this.getStatus(item).id == 2)
        )
          passed = false;
      });
      return passed;
    },
    allNotPassed() {
      // at least 1 not answered correctly
      let val = false;
      this.allUserCompliance.map((item) => {
        if (!this.getIsOptional(item) && this.getStatus(item).id == 2)
          val = true;
      });
      return val;
    },
    allNotFilled() {
      // at least 1 not filled
      let val = false;
      this.allUserCompliance.map((item) => {
        if (!this.getIsOptional(item) && this.getStatus(item).id == 0)
          val = true;
      });
      return val;
    },
    allOptional() {
      let val = true;
      this.allUserCompliance.map((item) => {
        if (!this.getIsOptional(item)) val = false;
      });
      return val;
    },
    handleCovidType() {
      switch (this.form.vaccine_pcr) {
        case "vaccine":
          return "covid_vaccine";
        case "pcr":
          return "covid_pcr";
        default:
          break;
      }
    },
    selectAction(action) {
      this.approveClicked = action == "approve";
      this.rejectClicked = action == "reject";
      console.log("this.approveClicked", this.approveClicked);
      this.setApproveVisit(this.approveClicked);
      this.setRejectVisit(this.rejectClicked);
      // setTimeout(() => {
      this.nextTab(null);
      // }, 200);
    },
    cc(data, desired, index) {
      if (!data) {
        console.log("cc", data, desired, this.checkValidation);
        return;
      }
      data.pivot.answer.desired = desired;
      // data.pivot.answer.text = text;
      data.pivot.answer.yesAnswer = data.answers[index].yesAnswer;
      console.log("cc", data, desired, this.checkValidation);
    },
    checkExpired() {
      if (
        (this.form.vaccine_pcr == "pcr" &&
          this.pcr.pcr_result?.id == "positive") ||
        (this.form.vaccine_pcr == "vaccine" &&
          this.vaccine.vaccine_expire_date <
            moment.utc(new Date()).tz(moment.tz.guess()).format("YYYY-MM-DD"))
      )
        this.is_expired = true;
      else this.is_expired = false;
    },
    nextTab(data) {
      console.log("next tabe", data);
      this.data = data;

      if (this.data) {
        // this.is_expired = false;
        this.checkIfStandalone({
          id: this.$router.currentRoute.params.id,
          onlineCompliance: this.onlineCompliance,
        }).then((res) => {
          console.log("chekstabdlone", res);
          if (
            this.data.form_metadata &&
            this.data.form_metadata.data &&
            this.data.form_metadata.data[0]
          ) {
            this.isPcrEnabled = this.data.form_metadata.data[0].pcr;
          }
          this.data.notes =
            this.data.pivot && this.data.pivot.metadata
              ? this.data.pivot.metadata[0]
                ? this.data.pivot.metadata[0].notes
                : this.data.pivot.metadata.notes
              : "";
          if (
            this.data.type == "vaccine_document" &&
            this.data.pivot &&
            this.data.pivot.user_documents_metadata
          ) {
            const documentSelected = this.vaccine.documentOptions.find(
              (item) => item.id == this.data.pivot.user_document_id
            );
            if (documentSelected) this.form.document = documentSelected;
            else this.form.document = null;

            this.form.vaccine_pcr =
              this.data.pivot.user_documents_type == "covid_vaccine"
                ? "vaccine"
                : "pcr";
            console.log("this.form.vaccine_pcr", this.form.vaccine_pcr);
            if (this.form.vaccine_pcr == "pcr")
              this.pcrFile = {
                img:
                  this.data.pivot.metadata &&
                  this.data.pivot.metadata.fileAttach
                    ? this.data.pivot.metadata.fileAttach
                    : "",
              };
            else if (this.form.vaccine_pcr == "vaccine")
              this.documentFile = {
                img:
                  this.data.pivot.metadata &&
                  this.data.pivot.metadata.fileAttach
                    ? this.data.pivot.metadata.fileAttach
                    : "",
              };
            this.form.notes = JSON.parse(
              this.data.pivot.user_documents_metadata
            ).notes;
            if (this.form.vaccine_pcr == "vaccine") {
              this.vaccine.vaccine_name = JSON.parse(
                this.data.pivot.user_documents_metadata
              ).certificateModel.vaccinations[0].vaccine;
              this.vaccine.vaccine_number = JSON.parse(
                this.data.pivot.user_documents_metadata
              ).certificateModel.vaccinations[0].batchNumber;
              this.vaccine.vaccine_given_date = JSON.parse(
                this.data.pivot.user_documents_metadata
              ).certificateModel.vaccinations[0].dateOfVaccination;
              this.vaccine.vaccine_expire_date = moment(
                JSON.parse(this.data.pivot.user_documents_metadata)
                  .greenCertificatData.expirationTime
              ).format("DD/MM/YYYY");
              this.vaccine.vaccine_protocol = JSON.parse(
                this.data.pivot.user_documents_metadata
              ).protocol;
              this.is_expired = this.data.pivot.is_expiry;
            } else {
              console.log("pcr");
              this.pcr.pcr_result =
                JSON.parse(this.data.pivot.user_documents_metadata)
                  .certificateModel.tests[0].testResult == "Detected"
                  ? {
                      id: "positive",
                      name: "Positive PCR",
                    }
                  : {
                      id: "negative",
                      name: "Negative PCR",
                    };
              this.pcr.pcr_date = JSON.parse(
                this.data.pivot.user_documents_metadata
              ).certificateModel.tests[0].dateTimeOfTestResult;
              this.is_expired =
                this.pcr.pcr_result.id == "positive" ? true : false;
            }
          } else if (
            this.data.type == "vaccine_document" &&
            this.data.pivot &&
            this.data.pivot.length == 0
          ) {
            this.form.vaccine_pcr = "vaccine";
            this.form.notes = "";
            this.vaccine.vaccine_name = "";
            this.vaccine.vaccine_number = "";
            this.vaccine.vaccine_given_date = "";
            this.vaccine.vaccine_expire_date = "";
            this.pcr.pcr_result = null;
            this.pcr.pcr_date = "";
          }
        });
      }
      setTimeout(() => {
        this.$refs.comp_form.nextTab();
      }, 200);
    },

    navigateToTab() {
      // this.allUserCompliance.map(item => {
      //   console.log('item.originalPivot', item.originalPivot);
      //   item.pivot = item.originalPivot;
      //   item.notes = item.originalNotes;
      // });
      this.checkIfStandalone({
        id: this.$router.currentRoute.params.id,
        onlineCompliance: this.onlineCompliance,
      }).then(() => {
        console.log(this.allUserComplianceFn());
        if (this.$refs.comp_form) this.$refs.comp_form.changeTab(2, 0);
      });
    },

    getStatus(data) {
      let text;
      let id;
      // id = 0 => ready to fill
      // id = 1 => compliance passed, compliance completed
      // id = 2 => compliance didn't pass the policy
      // id = 3 => compliance not passed (justified)
      const questions = data.form_metadata.questions
        ? data.form_metadata.questions
        : data.form_metadata.data;
      if (
        data.pivot &&
        data.pivot.metadata &&
        data.pivot.metadata[0] &&
        data.pivot.metadata.length == questions.length
      ) {
        // All Filled
        text = this.$t("complianceList.compliancePassed");
        id = 1;
        if (this.getIsOptional(data)) {
          text = "Compliance completed";
        } else if (data.type == "vaccine_document") {
          data.originalPivot.metadata.map((item) => {
            if (
              data.originalPivot.metadata[0].Document_status != "valid" &&
              !item.notes
            ) {
              text = this.$t("complianceList.compliancePolicy");
              id = 2;
            }
          });
        } else {
          data.pivot.metadata.map((item) => {
            if (!JSON.parse(item.answer.desired) && !item.notes) {
              text = this.$t("complianceList.compliancePolicy");
              id = 2;
            } else if (!JSON.parse(item.answer.desired) && !!item.notes) {
              text = this.$t("complianceList.complianceJustified");
              id = 3;
            }
          });
        }
        return { id, text };
      } else if (data.pivot && data.pivot.metadata) {
        // vaccine doc
        // All Filled
        text = this.$t("complianceList.compliancePassed");
        id = 1;
        if (data.pivot.metadata.isWrong && !data.pivot.metadata.notes) {
          text = this.$t("complianceList.compliancePolicy");
          id = 2;
        }
        if (data.pivot.metadata.isWrong && !!data.pivot.metadata.notes) {
          text = this.$t("complianceList.complianceJustified");
          id = 3;
        }
        if (this.getIsOptional(data)) {
          text = this.$t("complianceList.complianceCompleted");
        }
        return { id, text };
      } else if (data.isDue) {
        // vaccine doc
        // All Filled
        text = `${this.$t("complianceList.DueAt")} ${data.due}`;
        id = 0;
        // if (this.getIsOptional(data)) {
        //   text = "Compliance completed";
        // }
        return { id, text };
      } else return { id: 0, text: this.$t("complianceList.availableToFill") }; // Not Filled or Partly Filled
    },

    getUserStatus(data) {
      let text;
      let id;
      // id = 0 => ready to fill
      // id = 1 => compliance passed, compliance completed
      // id = 2 => compliance didn't pass the policy
      // id = 3 => compliance not passed (justified)
      const questions = data.form_metadata.questions
        ? data.form_metadata.questions
        : data.form_metadata.data;
      if (
        data.originalPivot &&
        data.originalPivot.metadata &&
        data.originalPivot.metadata[0] &&
        data.originalPivot.metadata.length == questions.length
      ) {
        // All Filled
        text = this.$t("complianceList.compliancePassed");
        id = 1;
        if (this.getIsOptional(data)) {
          text = this.$t("complianceList.complianceCompleted");
        } else if (data.type == "vaccine_document") {
          data.originalPivot.metadata.map((item) => {
            if (
              data.originalPivot.metadata[0].Document_status != "valid" &&
              !item.notes
            ) {
              text = this.$t("complianceList.compliancePolicy");
              id = 2;
            }
          });
        } else {
          data.originalPivot.metadata.map((item) => {
            if (!JSON.parse(item.answer.desired) && !item.notes) {
              text = this.$t("complianceList.compliancePolicy");
              id = 2;
            } else if (!JSON.parse(item.answer.desired) && !!item.notes) {
              text = this.$t("complianceList.complianceJustified");
              id = 3;
            }
          });
        }
        return { id, text };
      } else if (data.originalPivot && data.originalPivot.metadata) {
        // vaccine doc
        // All Filled
        text = this.$t("complianceList.compliancePassed");
        id = 1;
        if (
          data.originalPivot.metadata.isWrong &&
          !data.originalPivot.metadata.notes
        ) {
          text = this.$t("complianceList.compliancePolicy");
          id = 2;
        }
        if (data.originalPivot.metadata.isWrong && !!data.originalPivot.metadata.notes) {
          text = this.$t("complianceList.complianceJustified");
          id = 3;
        }
        if (this.getIsOptional(data)) {
          id = 1;
          text = this.$t("complianceList.complianceCompleted");
        }
        return { id, text };
      } else if (data.isDue) {
        // vaccine doc
        // All Filled
        text = `${this.$t("complianceList.DueAt")} ${data.due}`;
        id = 0;
        // if (this.getIsOptional(data)) {
        //   text = "Compliance completed";
        // }
        return { id, text };
      } else return { id: 0, text: this.$t("complianceList.availableToFill") }; // Not Filled or Partly Filled
    },

    getIsOptional(data) {
      if (data.type == "vaccine_document") {
        let optional = true;
        const questions =
          data.type == "vaccine_document" && data.form_metadata.data
            ? data.form_metadata.data
            : data.form_metadata.questions;
        questions.map((question) => {
          const notOptional = question.answers.find(
            (answer) => !JSON.parse(answer.desired)
          );
          if (notOptional) optional = false;
        });
        return optional;
      }
      return false;
    },

    getDate(date) {
      return moment
        .utc(date)
        .tz(moment.tz.guess())
        .format("DD/MM/YYYY - h:mm A");
    },
    getDay(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    disabledExpiredDate(date) {
      const [givenDateDay, givenDateMonth, givenDateYear] =
        this.vaccine.vaccine_given_date.toString().split("/");
      const newGivenDate = new Date(
        `${givenDateYear}-${givenDateMonth}-${givenDateDay}`
      );
      return date < newGivenDate;
    },

    disableDateAfterCurrent(date) {
      return date > new Date();
    },

    submitForm() {
      this.isLoading = true;
      console.log("submitForm", this.data, this.form, this.vaccine, this.pcr);
      this.checkIfStandalone({
        id: this.$router.currentRoute.params.id,
        onlineCompliance: this.onlineCompliance,
      }).then(() => {
        const complinaces = [];
        if (this.data.type !== "vaccine_document") {
          // this.isLoading = true;
          const data = this.data.form_metadata.questions;
          for (let i = 0; i < data.length; i++) {
            complinaces.push({
              complianceId: this.data.id,
              body: this.data.form_metadata.questions[i].body,
              type: this.data.form_metadata.questions[i].type,
              notes: this.data.notes,
              actionBy: this.onlineCompliance ? "User" : "Admin",
              answer: {
                answerImage: "answerImg",
                desired:
                  this.data.form_metadata.questions[
                    i
                  ].pivot.answer.desired.toString(),
                text: this.data.form_metadata.questions[i].pivot.answer.text,
                yesAnswer:
                  this.data.form_metadata.questions[
                    i
                  ].pivot.answer.yesAnswer.toString(),
              },
            });
          }
          complinaces.map((item) => {
            item["isWrong"] = !!complinaces.find(
              (comp) => !JSON.parse(comp.answer.desired)
            );
          });

          console.log("complinaces", complinaces);
          const bodyRequest = {
            answer: complinaces,
            name: this.data.name,
            isCompleted:
              this.allAnswered(this.data.id) &&
              !this.visitRejected &&
              !this.visitApproved
                ? 1
                : 0,
            isWrong: !!complinaces.find(
              (comp) => !JSON.parse(comp.answer.desired)
            ),
          };
          if (this.onlineCompliance) {
            console.log("this.bodyRequest", bodyRequest);
            this.createUserOnlineCompliance(bodyRequest)
              .then(() => {
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
          } else {
            this.createUserCompliance(bodyRequest)
              .then(() => {
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        } else {
          const {
            form,
            vaccine,
            pcr,
            currentEntity,
            handleCovidType,
            // createDocument,
          } = this;
          const { document, notes, vaccine_pcr } = form;
          const {
            vaccine_name,
            vaccine_number,
            vaccine_given_date,
            vaccine_expire_date,
          } = vaccine;
          const { pcr_result, pcr_date } = pcr;
          const { firstName, lastName, id } = this;
          //   validation
          this.submitted = true;
          this.$v.$touch();
          if (this.$v.$invalid && !document) {
            console.log("invalid");
            this.isLoading = false;
            return;
          }

          // this.isLoading = true;
          const vaccineData = {
            protocol: this.vaccine.vaccine_protocol,
            certificateModel: {
              extraData: {},
              dateOfBirth: "",
              kid: "",
              person: {
                familyName: lastName,
                givenName: firstName,
                standardisedFamilyName: lastName,
                standardisedGivenName: firstName,
              },
              signature: "",
              vaccinations: [
                {
                  certificateIdentifier: "",
                  certificateIssuer: "",
                  countryOfVaccination: "",
                  dateOfVaccination: vaccine_given_date,
                  disease: "COVID-19",
                  doseNumber: "",
                  manufacturer: "",
                  medicinalProduct: "",
                  totalSeriesOfDoses: "",
                  batchNumber: vaccine_number,
                  vaccine: vaccine_name,
                },
              ],
            },
            generalVerificationResult: "",
            greenCertificatData: {
              expirationTime: moment(vaccine_expire_date, "DD/MM/YYYY").format(
                "YYYY-MM-DD HH:mm:ss"
              ),
              issuedAt: "",
              issuingCountry: "",
            },
            type: "",
            notes,
          };
          const pcrData = {
            certificateModel: {
              dateOfBirth: "",
              kid: "",
              person: {
                familyName: lastName,
                givenName: firstName,
                standardisedFamilyName: lastName,
                standardisedGivenName: firstName,
              },
              signature: "",
              tests: [
                {
                  disease: "",
                  typeOfTest: "",
                  testName: "",
                  testNameAndManufacturer: null,
                  dateTimeOfCollection: "",
                  // dateTimeOfTestResult: pcr_date,
                  dateTimeOfTestResult: pcr_date
                    ? moment(pcr_date, "DD/MM/YYYY").format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    : "",
                  testResult:
                    pcr_result && pcr_result.id == "positive"
                      ? "Detected"
                      : "Not detected",
                  testResultCode:
                    pcr_result && pcr_result.id == "positive"
                      ? "260373001"
                      : "260415000",
                  testingCentre: "",
                  countryOfVaccination: "",
                  certificateIssuer: "",
                  certificateIdentifier: "",
                  countryCode: "",
                },
              ],
            },
            generalVerificationResult: "",
            greenCertificatData: {
              expirationTime: "",
              issuedAt: "",
              issuingCountry: "",
            },
            type: "INTERNATIONAL",
            notes,
          };
          const data = {
            entity_id: currentEntity.id,
            user_id: id,
            document: document && document.id,
            expiry_date: moment(vaccine_expire_date, "DD/MM/YYYY").format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            start_date: vaccine_pcr == "vaccine" ? null : pcr_date,
            type: handleCovidType(),
            notes,
            metadata: vaccine_pcr == "vaccine" ? vaccineData : pcrData,
          };
          console.log("create doc", data);
          const uploadedFile =
            vaccine_pcr == "vaccine"
              ? this.vaccineUploadedImg
              : this.pcrUploadedImg;

          // for (let pair of formData.entries()) {
          //   console.table(pair[0]+ ', ' + pair[1]);
          // }
          // this.createUserCompliance(formData);

          const bodyRequest = {
            data,
            isCompleted:
              this.allAnswered(this.data.id) &&
              !this.visitRejected &&
              !this.visitApproved
                ? 1
                : 0,
            uploadedFile,
            //isWrong: false,
            document_id: document && document.id,
            notes: this.data.notes,
            vaccine: true,
            complianceId: this.data.id,
          };

          if (this.onlineCompliance) {
            this.createUserOnlineCompliance(bodyRequest).then(() => {
              this.isLoading = false;
              this.documentFile.img = this.pcrFile.img = null;
            });
          } else {
            this.createUserCompliance(bodyRequest).then(() => {
              this.isLoading = false;
              this.documentFile.img = this.pcrFile.img = null;
            });
          }
        }
      });
    },

    approveOrRejectVisit(approve) {
      this.isLoading = true;
      if (this.visitApproved) {
        this.rejectApprovedVisit({
          visit_id: this.visitId,
          entity_id: this.currentEntity.id,
          notes: this.reason,
        }).then(() => {
          this.isLoading = false;
        });
      } else if (this.visitRejected) {
        this.approveRejectedVisit({
          visit_id: this.visitId,
          entity_id: this.currentEntity.id,
        }).then(() => {
          this.isLoading = false;
        });
      } else if (approve)
        this.approveVisit({
          visit_id: this.visitId,
          entity_id: this.currentEntity.id,
        }).then(() => {
          this.isLoading = false;
        });
      else
        this.rejectVisit({
          visit_id: this.visitId,
          entity_id: this.currentEntity.id,
          notes: this.reason,
        }).then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.cursor-zoomin {
  cursor: zoom-in;
  // height: 100%;
  width: 100%;
}
.img-agr {
    // border: 2px solid #F2F2F2;
    // border-radius: 8px;
    // padding: 12px;
    height: auto;
    width: 416px;
}
.online-compliance {
  .radio-disabled {
    cursor: not-allowed;
    pointer-events: none;
  }
  .radio-disabled-with-opacity {
    opacity: 0.4;
  }
  label.custom-control-label {
    color: var(--Grey-1, #787878) !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 17px;
    letter-spacing: 0.25px;
    padding-inline-start: 16px;
    padding-top: 5px;
  }
  .custom-control-label:before {
    background-color: #fff;
    width: 1.25rem;
    height: 1.25rem;
    border: 2.5px solid #103f5e;
    top: 0.3125rem;
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #fff !important;
    border: 2.5px solid #103f5e !important;
  }
  .custom-control-input:checked ~ .custom-control-label {
    font-weight: 700 !important;
    padding-inline-start: 16px !important;
    color: #103f5e !important;
    padding-inline-start: 16px !important;
  }
  .custom-control-input:checked ~ .custom-control-label:after {
    background-image: none;
    background-color: #103f5e;
    border-radius: 100%;
    background-image: none !important;
  }
  .custom-control-label:after {
    width: 0.75rem !important;
    height: 0.75rem !important;
    top: 0.565rem !important;
    inset-inline-start: -1.25rem !important;
  }
  .compliance-secondScreen {
    position: relative;
    margin: 69px auto 10px auto;
  }
}

.online-comp-width {
  width: 500px;
  padding: 40px 42px 40px;
}
.compliance-secondScreen {
  background: #ffffff !important;
  border-radius: 26px;
  // padding-bottom: 38px;
  // .notes-form {
    .compfillin-note {
    font-size: 14px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #787878;
    margin-top: 8px;
    margin-inline-start: 20px;
    }
    .compliance-note-label {
    position: absolute;
    margin-inline-start: 20px;
    margin-top: 10px;
    z-index: 2;
    color: #103f5e;
    font-size: 12px;
    // opacity: 0.8;

    font-weight: 700;

    line-height: 17px;
    letter-spacing: 0.25px;
    // opacity: 0.8;
  // }
  }
  .note-textarea {
    background-color: #f2f2f2 !important;
    border-color: #f2f2f2 !important;
    width: 415px;
    height: 100px;
    border: none;
    resize: none;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: #787878 !important;
    // opacity: 0.8 !important;
    border-radius: 4px;
    padding-inline-start: 20px !important;
  }
  .has-value {
    font-weight: 700 !important;
    color: #4A4A4A !important;
  }
  .remove-padding {
    padding-top: -10px !important;
  }
  .top-padding {
    padding-top: 26px !important;
  }
  .vaccine-answers-cont {
    background: #f2f2f2;
    border-radius: 4px;
    width: 415px;
    margin: 13px auto 40px auto;
    padding-top: 8px;
    padding-inline-start: 20px;
    padding-bottom: 8px;
    .sep-between-quessions {
      height: 1px;
      width: 409px;
      margin-inline-start: -14px;
      background: #000000;
      opacity: 0.08;
    }
    p.questions {
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      margin-top: 16px;
      margin-bottom: 5px;
      color: #939393;
    }
    p.answers {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      margin-bottom: 16px;
      color: #495057;
    }
    .img-bg {
      z-index: 4;
      width: 50.5px;
      height: 38.4px;
      border-radius: 5px !important;
      bottom: 7px;
      border: 0px;
    }
    img.img-file {
      position: absolute;
      z-index: 4;
      width: 50.5px;
      height: 38.4px;
      border-radius: 5px !important;
      bottom: 7px;
      inset-inline-start: 140px;
      border: 0px;
    }
  }
  .diffrentactions-btns {
    margin-bottom: 0px !important;

    .custom-backBtn {
      width: 415px;
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      margin-top: 0px !important;
      text-align: center;
      letter-spacing: 0.25px;
      margin: auto !important;
      color: #ffffff;
    }
  }
  img.unselectable.text-center {
    // margin-top: 40px;
    margin-bottom: 24px;
  }
  .modal-header-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 24px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
  }
  p.visitcard-status {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #4A4A4A;
    margin-top: 32px;
    text-align: center;
    margin: 32px auto 0 auto;
    width: 416px;
  }

  .online-compliance-user-details {
    font-weight: 400;
    font-size: 14px;
    width: 394px;
    letter-spacing: 0.25px;
    line-height: 24px;
    margin: 0 auto 27px auto;
    text-align: center;
    color: #666666 !important;
  }
}

.visit-register-header-comp {
    background: #ffffff;
    justify-items: center;
    border-start-end-radius: 26px;
    border-start-start-radius: 26px;
    .logo {
      display: block;
      // width: 86px;
      // margin: 0 auto;
      padding-bottom: 24px;
      .logo-img {
        width: auto;
        height: 20px;
      }
    }
    // .img-logo {
    //   min-height: 20px;
    //   max-height: 64px;
    //   height: auto;
    //   width: auto;
    // }
  }

.compliance-firstscreen {
  background: #ffffff;
  border-radius: 26px;
  margin: auto;
  .allcard-container {
    width: 416px;
    // height: 72px;
    margin: auto;
    align-items: center;
    margin-bottom: 16px;
    background: #F2F2F2;
    border-radius: 5px;
    position: relative;
    padding: 16px;
  }
  .card-left {
    display: flex;
    background: #F2F2F2;
    margin-inline-end: 16px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
  }
  .card-centercontent {
    background-color: #F2F2F2;
    height: 100%;
    width: 315px;
    .card-data {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      min-height: 12px;
      word-break: break-word;
      span.name {
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        color: #4A4A4A;
        width: 416px;
      }
    }
    .card-status {
      height: 12px;
      display: flex;
      align-items: center;
      span.status {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: 0.25px;
        color: #103f5e;
      }
      span.second-status {
        font-weight: 400;
        font-size: 16px;
        line-height: 17px;
        /* identical to box height, or 106% */

        letter-spacing: 0.25px;

        color: #787878;
      }
    }
  }
  .card-right {
    background: #F2F2F2;
    display: flex;
    align-items: center;
    border-radius: 5px;
    position: absolute;
    inset-inline-end: 16px;
  }
  :dir(rtl) .card-right svg {
    transform: scaleX(-1);
  }
  section.no-usr-pre-reg-head-tab1 {
    // background: blue!important;
    .welcome-msg {
      text-transform: uppercase;
      font-family: "lato";
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #000000;
      text-align: center;
      margin-bottom: 32px;
    }
    .online-compliance-user-details {
      font-weight: 400;
      font-size: 16px;
      width: 416px;
      letter-spacing: 0.25px;
      line-height: 24px;
      margin: 0 auto 40px auto;
      text-align: center;
      color: #4A4A4A !important;
    }
  }
}

///////////////////////////////////////////end of custom ui ///////////////////////////////
.break-word {
  word-break: break-word;
}
.closing-overlay {
  width: 415px;
  display: flex;
  height: 55px;
  align-items: center;
  background: #f2f2f2;
  justify-content: space-between;
  border-radius: 4px;
  h4.overlay-con {
    padding-inline-start: 20px;

    font-weight: 700;
    font-size: 16px;
    margin-top: 10px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #103f5e;
  }
  span.overlay-closing {
    padding-inline-end: 16px;
    padding-inline-end: 16px;

    font-size: 16px;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #f46a6a;
    cursor: pointer;
  }
}
.note-sep-line {
  background: #000000;
  opacity: 0.08;
  height: 1px;
  margin-top: 27px;
}
@media (max-width: 992px) {
  .online-comp-width {
    width: 375px;
  }

  .compliance-firstscreen {
    background: #ffffff !important;
    box-shadow: #ffffff;
    border-radius: 0px;
    padding-bottom: 157px;

    section.no-usr-pre-reg-head-tab1 {
      // background: blue!important;
      .visit-register-header-comp {
        background: #ffffff !important;
        box-shadow: #ffffff !important;
        border-start-end-radius: 0px !important;
        border-start-start-radius: 0px !important;
        margin-top: 0px !important;
        // margin-bottom: 24px!important;
        .logo {
          display: block;
          width: 116px !important;
          height: 22px !important;
          margin: 0 auto;

          padding-top: 63px !important;
        }
        .welcome-msg {
          // margin-top: 24px!important;
          margin-bottom: 24px !important;
        }
      }
      .online-compliance-user-details {
        font-weight: 400;
        font-size: 16px !important;
        width: 307px !important;
        letter-spacing: 0.25px;
        line-height: 27px !important;
        margin: 0 auto 32px auto !important;
        text-align: center;
        color: #666666 !important;
      }
    }
    .allcard-container {
      width: 308px;
      height: 80px !important;
      margin: auto;
      align-items: center;
      margin-bottom: 14px !important;
      background: #F2F2F2;
      border-radius: 5px;
      position: relative;
      padding: 16px;
    }
    .card-centercontent {
      background-color: #F2F2F2;
      height: 100%;
      width: 315px;
      .card-data {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        min-height: 12px;
        word-break: break-word;
        span.name {
          font-weight: 600;
          font-size: 14px !important;
          line-height: 19px;
          color: #4A4A4A;
        }
      }
      .card-status {
        height: 12px;
        display: flex;
        align-items: center;
        span.status {
          font-weight: 700;
          font-size: 14px !important;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #103f5e;
        }
        span.second-status {
          font-weight: 400;
          font-size: 14px !important;
          line-height: 17px;
          /* identical to box height, or 106% */

          letter-spacing: 0.25px;

          color: #787878;
        }
      }
    }

    .card-right {
      background: #F2F2F2;
      display: flex;
      align-items: center;
      border-radius: 5px;
      position: absolute;
      right: 16px;
    }
  }

  .compliance-secondScreen {
    background: #ffffff !important;
    border-radius: 0px !important;
    padding-bottom: 46px !important;
    margin-top: 0px !important;
    .vaccine-inputs-wrapper {
      .form-group.m-d-gruop.vaccine-name,
      .form-group.m-d-gruop.batch-num {
        margin-bottom: 0px;
      }
      width: 309px !important;
      img.img-file {
        inset-inline-start: 250px;
      }
      .file-note-text {
        font-weight: 700;
        font-size: 12px !important;
        line-height: 17px;
        text-align: start;

        letter-spacing: 0.25px;

        max-width: 280px !important;

        color: #939393;

        opacity: 0.8;
      }
      button.upload-btn {
        width: 309px;
        .paperclip-icon {
          inset-inline-start: 100px;
        }
      }
      .mx-input-wrapper {
        width: 147px !important;
      }
    }

    .pcr-inputs-wrapperr {
      width: 309px;
      margin-bottom: 128px;
      .file-note-text {
        font-weight: 700;
        font-size: 12px !important;
        line-height: 17px;
        text-align: initial;
        margin-inline-start: 60px;
        letter-spacing: 0.25px;
        text-align: start;
        color: #939393;

        opacity: 0.8;
      }
      .pcr-datepicker {
        width: 147px !important;
      }
      button.upload-btn {
        width: 147px !important;
        margin-inline-start: 60px;
        .paperclip-icon {
          position: relative;
          inset-inline-end: 50px;
        }
      }
    }
    .facemask-questioncon {
      margin-inline-start: 33px;
    }
    .vaccine-answers-cont {
      background: #f2f2f2;
      border-radius: 4px;
      width: 309px;
      margin: 13px auto 40px auto;
      padding-top: 8px;
      padding-inline-start: 20px;
      padding-bottom: 8px;
      .sep-between-quessions {
        height: 1px;
        width: 309px;
        margin-inline-start: -20px;
        background: #000000;
        opacity: 0.08;
      }
      p.questions {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        margin-top: 16px;
        margin-bottom: 5px;
        color: #939393;
      }
      p.answers {
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        margin-bottom: 16px;
        color: #495057;
      }
      .img-bg {
        z-index: 4;
        width: 50.5px;
        height: 38.4px;
        border-radius: 5px !important;
        bottom: 7px;
        border: 0px;
      }
      img.img-file {
        position: absolute;
        z-index: 4;
        width: 50.5px;
        height: 38.4px;
        border-radius: 5px !important;
        bottom: 7px;
        inset-inline-start: 140px;
        border: 0px;
      }
    }
    .diffrentactions-btns {
      margin-bottom: 0px !important;
      button.btn.text-center.custom-back.btn-primary.rounded-pill {
        width: 32px !important;
        height: 32px !important;
      }
      .custom-sumbmitbtn {
        width: 253px !important;
        height: 37px !important;
      }
      .custom-backBtn {
        width: 309px !important;
        margin: auto !important;
        border-radius: 18.5px;
      }
    }
    .user-infocontainer {
      width: 309px;
    }
    img.unselectable.text-center {
      margin-top: 63px !important;
      margin-bottom: 24px !important;
      width: 116px !important;
      height: 22px !important;
    }
    .modal-header-title {
      font-weight: 700;
      font-size: 19px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #000000;
      margin-top: 0px !important;
      mix-blend-mode: normal;
      margin-bottom: 24px;
    }
    // p.visitcard-status {
    //   width: 323px;
    //   margin: 0px auto 362px auto;
    // }

    .online-compliance-user-details {
      font-weight: 400;
      font-size: 14px;
      width: 394px;
      letter-spacing: 0.25px;
      line-height: 24px;
      margin: 0 auto 27px auto;
      text-align: center;
      color: #666666 !important;
    }
  }
}
///////////////////////////end of custom ui media query /////////////////

div#visit_modal___BV_modal_content_ {
  background: #ffffff;
  min-width: 491px !important;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  z-index: 10001;
}
div#visit_modal___BV_modal_body_,
div[id*="compFillIn_modald"][id$="modal_body_"] {
  padding: 40px 42px 0 42px !important;
  .wizard-tab-content {
    min-height: unset !important;
  }
  .modal-actions-btns {
    margin-bottom: 24px !important;
  }
}
div#visit_modal___BV_modal_body_,
div[id*="compFillIn_modal"],
.online-comp-width {
  p.modal-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #000000;
    width: 416px;
  }
  .vue-form-wizard .wizard-tab-content {
    padding: 0px !important;
  }
  .vue-form-wizard {
    padding-bottom: 0px !important;
  }

  .modal-toptitle {
    width: 100%;
    margin-bottom: 24px;
  }
  .modal-closeing {
    margin-inline-end: 33px;
    cursor: pointer;
  }
  .modal-toptitle-left {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  p.modal-title-left {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    margin-bottom: 0px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000000 !important;
  }
  p.visitcard-status {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #4A4A4A;
    margin-top: 32px;
    text-align: center;
    margin: 32px auto 0 auto;
    width: 416px;
  }
  .user-infocontainer {
    background: #F2F2F2;
    width: 416px;
    margin: 24px auto 40px auto;
    border-radius: 4px;
    p.user-info {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #4A4A4A;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 28px;
    }
  }
  .facemask-questioncon {
    width: 416px;
    margin: auto;
    .response-err {
      font-size: 14px;
      font-weight: 400;
      margin-top: -8px;
      color: #787878;
      text-align: start;
    }
    .response-err-danger {
      color: #f46a6a !important;
    }
    p.facemask {
      font-weight: 400;
      font-size: 16px;
      word-break: break-word !important;
      line-height: 28px;
      letter-spacing: 0.25px;
      color: #4A4A4A;
      margin-bottom: 32px;
    }
    .radios-container {
      .v-input--radio-group__input {
        display: grid;
        gap: 24px;
      }
      .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
        margin-bottom: 0;
      }
      .text-danger label,
      .text-danger span {
        color: #f46a6a !important;
      }
      .text-success label,
      .text-success span {
        color: #34c38f !important;
      }
      .text-success,
      .text-danger {
        pointer-events: none;
      }
    }
  }
  .vaccine-title {
    color: #939393;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 20px;
  }
  .agreement-container {
    p.static-agreement {
      margin: 0px !important;
      word-break: break-word !important;
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #4A4A4A;
      text-align: center;
      width: 416px;
    }
  }

  :dir(rtl) .custom-back svg {
    transform: scaleX(-1);
  }
  .diffrentactions-btns {
    width: 100%;
    display: flex;
    margin-bottom: 38px;
    button.btn.text-center.custom-back.btn-primary.rounded-pill {
      width: 32px;
      height: 32px;
      align-items: center;
      justify-content: center;
      display: flex;
      background: #103f5e;
      position: absolute;
      inset-inline-start: 32px;
      top: 32px;
    }
    .custom-sumbmitbtn {
      background: #103f5e;

      margin-top: 16px;
      border-radius: 22px;
      width: 347px;
      height: 44px;
      span {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;

        text-align: center;
        letter-spacing: 0.25px;
        color: rgba(255, 255, 255, 0.87);
      }
    }
    button.btn.text-center.custom-backBtn.btn-primary.rounded-pill {
      background: #103f5e;

      margin-top: 16px;
      border-radius: 22px;
      width: 415px;
      height: 44px;
      span {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        text-align: center;
        letter-spacing: 0.25px;
        color: rgba(255, 255, 255, 0.87);
      }
    }
  }
  .documents {
    width: 415px !important;
    margin: 0px auto 32px auto;
    label {
      margin-top: 0px;
      margin-inline-end: auto;
      margin-bottom: 30px;
      margin-inline-start: 10px;
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #939393;
    }
    .multiselect__tags {
      height: 55px !important;
      background: #f2f2f2 !important;
      border-radius: 4px !important;
      border: none !important;
      span.multiselect__placeholder {
        background: transparent !important;
        margin-top: 10px !important;
        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 17px;
        margin-inline-start: 10px;
        letter-spacing: 0.25px;

        color: #787878;

        opacity: 0.8;
      }

      .multiselect__input {
        background: transparent !important;
      }
    }
  }
  .document-details {
    margin: 0px auto 35px auto;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    width: 248px;
    letter-spacing: 0.25px;
    color: #666666;
  }
  .vaccine-pcrradio {
    width: 225px;
    margin-inline-start: 54px;
    margin-bottom: 25px;
    label.custom-control-label {
      padding-inline-start: 20px;
    }
    .pcr-radio.custom-control.custom-radio {
      margin-inline-start: 56px;
    }
  }
  .vaccine-inputs-wrapper {
    width: 415px;
    margin: auto;
    input.mx-input {
      height: 55px !important;
      background: #f2f2f2 !important;
      border-radius: 4px;
      border: none !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      line-height: 17px !important;
      letter-spacing: 0.25px !important;
      color: #000000de !important;
    }
    div#date-vaccine {
      width: 200px !important;
      margin-inline-end: 15px;
      font-weight: 700 !important;
      font-size: 16px !important;
      line-height: 17px !important;
      letter-spacing: 0.25px;
      color: rgba(0, 0, 0, 0.87);
      opacity: 0.8;
      ::placeholder {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: 0.25px;
        color: #787878;
      }
    }
    div#expire_date {
      width: 200px !important;

      font-weight: 700 !important;
      font-size: 16px !important;
      line-height: 17px !important;
      letter-spacing: 0.25px;
      color: rgba(0, 0, 0, 0.87);
      opacity: 0.8;
      ::placeholder {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: 0.25px;
        color: #787878;
      }
    }
    .form-group.m-d-gruop.vaccine-name,
    .form-group.m-d-gruop.batch-num {
      margin-bottom: 0px;
    }
  }

  textarea#rejectTextarea {
    background: #f2f2f2 !important;
    border-radius: 4px;
    border: none !important;
    margin-top: 36px;
  }
  textarea#notesTextarea {
    background: #f2f2f2 !important;
    border-radius: 4px;
    border: none !important;
  }
  textarea#notes {
    background: #f2f2f2 !important;
    border-radius: 4px;
    width: 415px;
    margin: auto;
    border: none !important;
  }
  textarea::placeholder {
    font-weight: 400;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #787878;
  }
  .pcr-inputs-wrapperr {
    input.mx-input {
      height: 55px !important;
      background: #f2f2f2 !important;
      border-radius: 4px;
      border: none !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      line-height: 17px !important;
      letter-spacing: 0.25px !important;
      color: #000000de !important;
    }
    div#date-vaccine {
      width: 200px !important;
      margin-inline-end: 15px;
      font-weight: 700 !important;
      font-size: 16px !important;
      line-height: 17px !important;
      letter-spacing: 0.25px;
      color: rgba(0, 0, 0, 0.87);
      opacity: 0.8;
      ::placeholder {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: 0.25px;
        color: #787878;
      }
    }
    div#expire_date {
      width: 200px !important;
      font-weight: 700 !important;
      font-size: 16px !important;
      line-height: 17px !important;
      letter-spacing: 0.25px;
      color: rgba(0, 0, 0, 0.87);
      opacity: 0.8;
      ::placeholder {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: 0.25px;
        color: #787878;
      }
    }
    width: 415px;
    margin: auto;
  }

  .protocols-multiselect {
    margin-bottom: 15px;
    .multiselect__select {
      z-index: 5;
      margin-top: 5px;
    }
    .multiselect__tags {
      border: 0px !important;
      height: 55px;
      .multiselect__input {
        background-color: #f2f2f2 !important;
      }
    }
    .multiselect__single {
      position: relative;
      top: 11px;
      inset-inline-start: 12px;
      font-size: 16px !important;
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.25px;
    }
    .multiselect__tags,
    .multiselect__single {
      background-color: #f2f2f2 !important;
      border-radius: 4px;
    }
    .multiselect__placeholder {
      margin-top: 10px;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.25px;
    }
  }

  .pcr-inputs-wrapperr {
    .multiselect__tags {
      height: 55px !important;
      background: #f2f2f2 !important;
      border-radius: 4px !important;
      border: none !important;
      span.multiselect__placeholder {
        background: transparent !important;
        margin-top: 10px !important;
        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 17px;
        margin-inline-start: 10px;
        letter-spacing: 0.25px;

        color: #787878;

        opacity: 0.8;
      }
      span.multiselect__single {
        background: transparent !important;
        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 17px !important;
        letter-spacing: 0.25px !important;
        color: rgba(0, 0, 0, 0.87) !important;
        opacity: 0.8;
        margin-top: 10px !important;
        margin-inline-start: 10px !important;
      }
      .multiselect__input {
        background: transparent !important;
      }
    }
    input.mx-input {
      height: 55px !important;
      background: #f2f2f2 !important;
      border-radius: 4px;
      border: none !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      line-height: 17px !important;
      letter-spacing: 0.25px !important;
      color: #000000de !important;
    }
    input.mx-input::placeholder {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      letter-spacing: 0.25px;
      margin-inline-start: 20px;
      padding-inline-start: 10px;
      color: #787878;
    }
    i.mx-icon-calendar {
      margin-inline-end: 10px;
    }
  }
  .strong-txt {
    color: #363636;
    font-size: 15px;
  }
  .visit-permission {
    font-size: 16px;
    font-weight: 400;
    color: #4a4a4a;
    line-height: 23.28px;
    text-align: center;
    // margin: 0px auto 36px auto;
    p {
      margin: 0px !important;
      padding: 0px !important;
    }
  }
  .reason-txt {
    margin-bottom: 38px;
  }
  .aprove-reject {
    // padding: 40px 0px;
    font-size: 15px;
    font-weight: 400;
    color: #4a4a4a;
    line-height: 23.28px;
    text-align: center;
    margin-bottom: 32px;
  }
  .reason-txt {
    margin-bottom: 38px;
  }
  .firsttxt-card {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    width: 416px;
    text-align: center;
    letter-spacing: 0.25px;
    margin: 0 auto 40px auto;
    color: #4A4A4A;
    padding-top: 8px;
  }
  textarea {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    padding-top: 22px;
    letter-spacing: 0.25px !important;
    color: #787878 !important;
  }

  .upload-btn {
    background-color: #f2f2f2;
    color: #000000;
    width: 200px;
    height: 55px;
    border-radius: 4px;
    border: 0;
  }
  .file-label {
    color: #787878;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    min-width: 160px;
    margin-inline-start: 3px;
    margin-bottom: 10px;
  }
  .file-label-img-selected {
    color: #3d637c;
  }
  .logo-note-text {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #939393;
    width: 90%;
    margin: auto;
    margin-top: 6px;
    opacity: 80%;
  }
  .img-bg {
    z-index: 4;
    width: 50.5px;
    height: 38.4px;
    border-radius: 5px !important;
    bottom: 7px;
    border: 0px;
  }
  img.img-file {
    position: absolute;
    z-index: 4;
    width: 50.5px;
    height: 38.4px;
    border-radius: 5px !important;
    bottom: 7px;
    inset-inline-start: 140px;
    border: 0px;
  }
  .remove-btn {
    position: relative;
    bottom: 40px;
    inset-inline-start: 20%;
    width: 68px;
    height: 25px;
    border: none;
    color: #fff;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #ffffff;
    border-radius: 16px;
    background: #f46a6a;
  }

  .file-validation {
    border: red solid 1px;
  }
  .remove-file-icon {
    position: absolute;
    z-index: 5;
    width: 51px;
    height: 39px;
    border-radius: 5px;
    bottom: 7px;
    inset-inline-start: 140px;
    opacity: 0;
    color: #ffffff;
  }
  .remove-file-icon:hover {
    background-color: #666666;
    opacity: 0.8 !important;
    display: block;
  }

  .paperclip-icon {
    position: relative;
    inset-inline-end: 16px;
  }

  .file-note-text {
    font-size: 14px;
    text-align: start;
    line-height: 22.5px;
    letter-spacing: 0.25px;
    color: #939393;
    font-weight: 400;
    max-width: 200px;
    padding-inline-start: 15px;
    padding-inline-end: 15px;
    b {
      font-weight: 700;
    }
  }
  .file-err-text {
    font-size: 14px;
    line-height: 22.5px;
    letter-spacing: 0.25px;
    font-weight: 600;
    color: #f46a6a;
    max-width: 200px;
    padding-inline-start: 15px;
    padding-inline-end: 20px;
    text-align: start;
  }

  .pcr-datepicker {
    width: 200px !important;
  }

  .modal-optional-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #666666;
    margin-bottom: 26px;
    margin-top: 26px;
  }

  .scan-btn {
    width: 415px;
    height: 55px;
    margin: auto;
    background-color: #f2f2f2;
    border: none;
    border-radius: 4px;
    text-align: start;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #787878;
    padding: 15px;
  }

  .scan-icon {
    position: absolute;
    inset-inline-start: 360px;
    top: 8px;
  }

  .online-compliance-user-details {
    font-weight: 400;
    font-size: 14px;
    width: 394px;
    letter-spacing: 0.25px;
    line-height: 24px;
    margin: 0 55px 43px 55px;
    text-align: center;
    color: #666666;
  }

  .visit-register-header-comp {
    .logo-2 {
      display: block;
      width: 116px;
      height: 22px;
      margin: 0 auto;
      margin-bottom: 20px;
      img {
        width: 116px;
        height: 22px;
      }
    }
    .form-title {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      color: #000;
      margin-bottom: 28px;
    }
    .sub-title {
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #666666;
      margin-bottom: 26px;
      .login-btn {
        color: #103f5e;
      }
    }
  }

  .welcome-msg {
    text-transform: uppercase;
    font-family: "lato";
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
    text-align: center;
    margin-bottom: 32px;
  }
}
</style>

<style lang="scss" scoped>
::v-deep {
.disabledWithOpacity {
  opacity: 0.4;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-stop {
    cursor: not-allowed;
  }
  input.mx-input {
    height: 55px !important;
    background: #f2f2f2 !important;
    border-radius: 4px;
    border: none !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    line-height: 17px !important;
    letter-spacing: 0.25px !important;
    color: #000000de !important;
  }
  div#date-vaccine {
    width: 200px !important;
    margin-inline-end: 15px;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 17px !important;
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.87);
    opacity: 0.8;
    ::placeholder {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      letter-spacing: 0.25px;
      color: #787878;
    }
  }
  div#expire_date {
    width: 200px !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 17px !important;
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.87);
    opacity: 0.8;
    ::placeholder {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;

      letter-spacing: 0.25px;

      color: #787878;
    }
  }
}
</style>
